import { text } from 'd3-fetch';
import mailcheck from 'mailcheck';
import { parseDonationUrlParams } from './url-prefill.js';

if (typeof allFormSettings !== 'undefined')
{
	// Only log stuff to the console if the env is not 'production'
	// const showDebug = true;
	const showDebug = allFormSettings.dev_mode;

	const RECAPTCHA_SITE_KEY = allFormSettings.recaptcha_site_key;

	// Main Donation Captcha Callback (now handles token from v3)
	window.onMainDonationSubmit = function(token)
	{

		// Processing Step 2
		if(showDebug) console.log('onMainDonationSubmit');
		if(showDebug) console.log(token);

		if(showDebug) console.log("CAPTCHA verified...");
		document.querySelector(".main-donation-form .jsOverlayProgressBar").value = 2;

		// Add token to input on the form
		document.getElementById('main-donation-captcha-response').value = token;
		// Trigger submit
		document.getElementById("main-donation-form-1").dispatchEvent(new Event("submit", { cancelable: true }));
		// document.getElementById('main-donation-form').-();
	}

	// Sidebar Donation Captcha Callback (now handles token from v3)
	window.onSidebarDonationSubmit = function(token)
	{
		if(showDebug) console.log('onSidebarDonationSubmit');
		if(showDebug) console.log(token);

		if(showDebug) console.log("CAPTCHA verified...");
		document.querySelector(".sidebar-donation-form .jsOverlayProgressBar").value = 2;

		// Add token to input on the form
		document.getElementById('sidebar-donation-captcha-response').value = token;
		// Trigger submit
		document.getElementById("sidebar-donation-form-1").dispatchEvent(new Event("submit", { cancelable: true }));
		// document.getElementById('sidebar-donation-form').submit();
	}

	// Require libs:69
	// const { text } = require('d3');

	// Global vars
	var stripe = null;
	var clientSecret = null;
	function getDefaultErrMsg()
	{
		if (typeof allFormSettings !== 'undefined' && allFormSettings.site_handle === 'ijmNl')
		{
			return 'Helaas! De donatie kon niet worden verwerkt. Ververs uw browser en probeer het opnieuw.';
		}
		return 'Oh no! The donation failed to process. Please refresh your browser and try again.';
	}

	// ── Uncaught-error safety net ─────────────────────────────────────────
	// Every other error path in this file is something the code
	// anticipated and reports via handleError()/logDonationError() with a
	// known "(Error-XXX)" code. This catches everything else -- a real,
	// unclassified crash -- so a donor left on a silently broken page
	// (blank card field, frozen overlay, anything neither of us thought
	// to guard against) leaves *some* trace instead of none. Registered
	// once at module scope (not inside the DonationForm class) since
	// main + sidebar-drawer both load this same bundle on one page, and a
	// single crash shouldn't produce duplicate rows.
	//
	// Deliberately fire-and-forget and wrapped so reporting a crash can
	// never itself become the thing that crashes.
	function reportUncaughtError(errorCode, message)
	{
		try
		{
			// ijmCa doesn't use this bespoke donation form (it's on
			// FundraiseUp) -- but sidebarDrawer.twig, which sets
			// allFormSettings and is what makes these listeners fire at
			// all, is included from the shared templates/_includes/
			// layout.twig used by every site. So this code still runs on
			// ijmCa pages even though nothing there ever submits through
			// it; any error under that site handle is noise from an
			// unrelated page, not a donation-form problem.
			if (allFormSettings.site_handle === 'ijmCa') return;

			// Wistia's own player/popover scripts throw dynamic-import
			// and transition errors unrelated to the donation form --
			// the unhandledrejection listener below has no filename
			// filter (see its own comment), so these otherwise flood
			// this log with third-party noise that has nothing to do
			// with donations.
			const messageStr = String(message);
			if (/wistia/i.test(messageStr)) return;

			const payload = {
				error_code: errorCode,
				message: messageStr.slice(0, 1000),
				email: document.querySelector('[name="email"]')?.value || '',
				amount: document.querySelector('[name="amount"]')?.value || '',
				frequency: document.querySelector('[name="frequency"]:checked')?.value || '',
				payment_method: document.querySelector('.jsDonationForm')?.dataset.paymentMethod || '',
				site_handle: allFormSettings.site_handle || '',
			};

			fetch('/make-gift/log-donation-error.php', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Donation-Log-Key': allFormSettings.donation_error_log_key,
				},
				body: JSON.stringify(payload),
			}).catch(() => {});
		}
		catch (e) { /* never let error reporting be the thing that throws */ }
	}

	window.addEventListener('error', (event) =>
	{
		// Only report errors actually thrown from this donation bundle's
		// own code -- otherwise this becomes a dumping ground for every
		// unrelated third-party script (ads, analytics, browser
		// extensions) that happens to be on the same /give/ page.
		if (!event.filename || !event.filename.includes('donationForm')) return;

		reportUncaughtError('JS0', `${event.message} at ${event.filename}:${event.lineno}:${event.colno}`);
	});

	window.addEventListener('unhandledrejection', (event) =>
	{
		const reason = event.reason;
		const message = reason instanceof Error ? (reason.stack || reason.message) : String(reason);
		reportUncaughtError('JS1', message);
	});

	// Utility for including js file
	function include(url, callback, onError)
	{
		var script = document.createElement('script');
		// script.onload = fn;
		script.src = url;
		script.async = false;
		script.addEventListener('load', callback);
		// Without this, a script blocked by an ad-blocker/privacy extension,
		// a network hiccup, or a corporate content filter fires neither
		// 'load' nor any JS error -- the promise below just hangs forever
		// with no console output and no indication anything went wrong (see
		// loadRecaptcha()).
		if (onError) script.addEventListener('error', onError);
		document.getElementsByTagName("head")[0].appendChild(script);
	}

	// Lazily load the reCAPTCHA v3 script. The donation widget is embedded in
	// the sidebar drawer on every page site-wide, so loading this eagerly
	// (previously registered unconditionally in <head> via donationWidget.twig)
	// meant every page paid its cost even when no one opened the donation
	// drawer. Safe to call repeatedly -- resolves immediately once loaded.
	let recaptchaLoading = null;
	function loadRecaptcha()
	{
		if (typeof grecaptcha !== 'undefined' && grecaptcha.ready)
		{
			return Promise.resolve();
		}
		if (!recaptchaLoading)
		{
			recaptchaLoading = new Promise((resolve, reject) => {
				// A hard cap on top of the 'error' listener above -- some
				// blockers (DNS-level, some corporate proxies) silently drop
				// the request without ever firing a load *or* error event on
				// the <script> tag at all. Without this, that failure mode
				// still hangs the donor on the processing overlay forever.
				const timeout = setTimeout(() => {
					reject(new Error('reCAPTCHA script load timed out'));
				}, 10000);
				include(
					`https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`,
					() => { clearTimeout(timeout); resolve(); },
					() => { clearTimeout(timeout); reject(new Error('reCAPTCHA script failed to load')); }
				);
			// A failed load must not be cached as "still loading" -- let the
			// next call to loadRecaptcha() (e.g. the donor clicking "Retry"
			// on showRecaptchaFailure()) try again from scratch instead of
			// replaying the same rejected promise forever.
			}).catch((error) => {
				recaptchaLoading = null;
				throw error;
			});
		}
		return recaptchaLoading;
	}

	// Loads reCAPTCHA if needed, then resolves a v3 token for the given
	// action. Shared by every call site that needs a token (check_customer,
	// sidebar_donate, main_donate) so the load/ready/execute plumbing only
	// exists once.
	function getRecaptchaToken(action)
	{
		return loadRecaptcha().then(() => new Promise((resolve, reject) => {
			grecaptcha.ready(() => {
				grecaptcha.execute(RECAPTCHA_SITE_KEY, { action })
					.then(resolve)
					.catch(reject);
			});
		}));
	}

	// Utility for checking for valid JSON
	function isValidJSON(text) {
		try
		{
			JSON.parse(text);
			return true;
		}
		catch
		{
			return false;
		}
	}

	// Utility for generating error json
	function setError(err_msg)
	{
		/*
		Example:
		{
			"status":"error",
			"code":"400",
			"message":"No such customer: 'cus_FkqinVnSVN3u83'; a similar object exists in live mode, but a test mode key was used to make this request."
		}
		*/
		// error = true;
		let errorJSON = {
			"status": "error",
			"code": "400",
			"message": err_msg
		};
		return errorJSON;
	}

	// Create the class for the Custom Element
	// class DonationForm extends HTMLElement
	class DonationForm
	{
		constructor(form, allFormSettings)
		{
			// dfc = Donation Form Container
			this.dfc = form;
			this.allFormSettings = allFormSettings;
			if (this.dfc) this.init();
		}

		// Runs when component is created
		init()
		{
			// Get namespace var
			this.ns = this.dfc.dataset.ns;

			// Assign the settings for the specific block
			this._settings = allFormSettings[this.ns + 'settings'];

			// IJM Netherlands: email links open donation pages with prefill parameters
			// (?email=&vnaam=&tv=&anaam=&amounts=&monthly-amounts=&amount=&frequency=&campaign=).
			// Parsed and sanitised in url-prefill.js; null everywhere else, so no other
			// site changes. Applied below (settings) and after the fields exist (values).
			this.urlPrefill = (allFormSettings.site_handle === 'ijmNl')
				? parseDonationUrlParams(window.location.search)
				: null;

			// Required libs (moved to top of file)
			// this.mailcheck = require('mailcheck');
	/*
		----------------------------------------------------------------------
			Properties
		----------------------------------------------------------------------
	*/
			this.form = this.dfc.querySelector('.jsDonationForm');
			// this.paginationControls = this.dfc.querySelectorAll('.jsPaginateTo');
			// Default 'card' for US/CA; IJM Netherlands' form tag renders
			// data-payment-method="ideal" (its first/default radio option)
			// instead, so this stays in sync with whichever radio the twig
			// actually checked by default.
			this.paymentMethod = this.form.dataset.paymentMethod || 'card';
			this.syncDirectDebitOnlyFields(this.paymentMethod);
			this.navButtonPrev = this.dfc.querySelectorAll('.jsPrevPage');
			this.navButtonNext = this.dfc.querySelectorAll('.jsNextPage');
			this.hiddenFields = this.dfc.querySelector('.jsHiddenFields');
			this.formPages = this.dfc.querySelectorAll('.jsFormPage');
			// Which type of recurrences should we show [true/false]
			this.recurrenceTypes =
			{
				single: (this.form.dataset.showSingle.toLowerCase() === 'true'),
				monthly: (this.form.dataset.showMonthly.toLowerCase() === 'true'),
				annual: (this.form.dataset.showAnnual.toLowerCase() === 'true'),
			};
			this.defaultRecurrence = this.form.dataset.defaultRecurrence;
			this.applyUrlPrefillSettings();
			this.form.dataset.recurrence = this.defaultRecurrence;
			this.syncIdealAvailability(this.defaultRecurrence);
			// this.hasSuggestedAmountsText = this.dfc.querySelector('.jsHasSuggestedAmountsText');
			this.donationRecurrenceText = this.dfc.querySelector('.jsDonationRecurrenceText');

			// this.suggestedAmountsWrapper = this.dfc.querySelector('.suggestedAmounts');
			this.amountWrapper = this.dfc.querySelector('.jsAmountWrapper');

			// Minimum Donations
			this.min =
			{
				single: this.form.dataset.minSingle,
				monthly: this.form.dataset.minMonthly,
				annual: this.form.dataset.minAnnual
			}

			// Maximum donation -- same ceiling regardless of frequency
			// (matches Data.php's ensureValidAmount()/ensureValidAmountNl(),
			// which don't branch on frequency either), so unlike this.min
			// above there's no per-recurrence breakdown.
			this.max = this.form.dataset.max;

			// Define error messages
			// IJM Netherlands shares these same field IDs (ns + 'first_name',
			// ns + 'email', etc. -- see donationWidget.twig's ijmNl branch),
			// so it needs its own set rather than falling through to the
			// English copy below. 'state' is skipped: ijmNl has no
			// billing_state field, so that key is simply never looked up
			// for it.
			this.errorMessages = {}
			if (allFormSettings.site_handle === 'ijmNl')
			{
				this.errorMessages[this.ns + 'targetAmount'] =
					{
						generic: "Vul een bedrag in om te doneren.",
						rangeUnderflow:
						{
							pre: "Voor dit type gift geldt een minimum van €",
							post: ".",
						}
					};
					this.errorMessages[this.ns + 'first_name'] = "Vul uw voornaam in.";
					this.errorMessages[this.ns + 'last_name'] = "Vul uw achternaam in.";
					this.errorMessages[this.ns + 'email'] =
					{
						generic: "Vul uw e-mailadres in.",
						invalidFormat: "Vul een geldig e-mailadres in (bijv. naam@voorbeeld.nl).",
					};
					this.errorMessages[this.ns + 'phone'] = "Vul uw telefoonnummer in.";
					this.errorMessages[this.ns + 'country'] = "Selecteer uw land.";
					this.errorMessages[this.ns + 'zip'] = "Vul uw postcode in.";
					this.errorMessages[this.ns + 'city'] = "Vul uw plaats in.";
					this.errorMessages[this.ns + 'address'] = "Vul uw straatnaam in.";
					// Same generic (empty) vs invalidFormat (filled in, but not a
					// Dutch IBAN -- see the pattern on the field) split as email.
					this.errorMessages[this.ns + 'iban'] =
					{
						generic: "Vul uw IBAN in.",
						invalidFormat: "Vul een geldig Nederlands IBAN in (bijv. NL91 ABNA 0417 1643 00).",
					};
				}
				else
				{
					this.errorMessages[this.ns + 'targetAmount'] =
					{
						generic: "Please specify an amount to donate.",
						rangeUnderflow:
						{
							// Pre and post the minimum amount, fetched dynamically
							pre: "There is a $",
							post: " minimum on donations of this type.",
						},
						rangeOverflow:
						{
							// Pre and post the maximum amount, fetched dynamically.
							// Previously this wasn't enforced client-side at all --
							// a donor typing e.g. $275,000 only found out at
							// client-secret.php's server-side check, surfaced as a
							// raw "Error-CSCS3" message rather than the same inline
							// field validation the minimum already gets.
							pre: "There is a $",
							post: " maximum on donations of this type.",
						},
					};
					this.errorMessages[this.ns + 'first_name'] =  "Please enter your first name.";
					this.errorMessages[this.ns + 'last_name'] =  "Please enter your last name.";
					this.errorMessages[this.ns + 'email'] =
					{
						generic: "Please enter your email.",
						// Filled in, but shaped wrong (patternMismatch: fails the
						// pattern= attribute below; typeMismatch: fails type="email"'s
						// own built-in check) -- distinct from simply empty, so the
						// donor knows what to fix instead of being told to enter
						// something they already entered.
						invalidFormat: "Please enter a valid email address (e.g. name@example.com).",
					};
					this.errorMessages[this.ns + 'phone'] =  "Please enter your phone number.";
					this.errorMessages[this.ns + 'country'] =  "Please select your country of residence.";
					this.errorMessages[this.ns + 'state'] =  "Please select a state from the list.";
					this.errorMessages[this.ns + 'zip'] =  "Please enter your zip/postal code.";
					this.errorMessages[this.ns + 'city'] =  "Please enter your city.";
					this.errorMessages[this.ns + 'address'] =  "Please provide your street address.";
				}

			// Amount fields
			this.visibleAmountField = this.dfc.querySelector('.jsVisibleAmount');
			this.totalAmountField = this.dfc.querySelector('.jsTotalAmount');
			// Unlike 'min' (set per-recurrence in recurrenceChanged()), the
			// max doesn't vary by frequency, so it's set once here rather
			// than re-set on every recurrence change.
			if (this.max) this.visibleAmountField.setAttribute('max', this.max);
			this.targetAmount = null;
			this.fees = null; // The fees amount is calculated based on the target amount
			this.amountIsDirty = false; // The amount field is considered "dirty" if the user has changed the value therein

			// Transaction fees
			this.transactionFeesCheckbox = this.dfc.querySelector('.jsCoverFees');
			this.feesLabel = this.dfc.querySelector('.jsTransactionFeesLabel');
			this.feesAmounts = this.dfc.querySelectorAll('.jsFeesAmount');
			this.syncFeeCoverAvailability(this.defaultRecurrence);

			// Payment Method
			this.paymentMethodFields = this.dfc.querySelectorAll('.jsPaymentMethod');

			// Summary
			this.summaryAmounts = this.dfc.querySelectorAll('.jsSummaryAmount');
			this.summaryCoverFees = this.dfc.querySelectorAll('.jsSummaryCoverFees');
			this.summaryRecurrences = this.dfc.querySelectorAll('.jsSummaryRecurrence');
			// this.summaryFees = this.dfc.querySelectorAll('.jsSummaryFees');

			// Give/submit button(s) whose text updates per recurrence (ijmNl's
			// final page-3 submit button -- "Geef"/"Geef maandelijks"/"Geef
			// jaarlijks", set in updateDonationSummaryAmount()). Was referenced
			// in that switch statement without ever being assigned here --
			// found while merging feature/ach in, which is what exposed it
			// (that branch never had this class on any button at all).
			this.giveButtonTextArr = this.dfc.querySelectorAll('.jsGiveButtonText');

			this.customerId = this.dfc.querySelector('[name="customer_id"]');

			this.inHonorOfWrapper = this.dfc.querySelector('.jsInHonorOfWrapper');

			// Credit Card
			this.card = null;
			this.cardElement = document.getElementById(`${this.ns}card-element`);
			this.cardErrors = document.getElementById(`${this.ns}card-errors`);
			// Stripe's card Element lives in an iframe -- it has no [required]
			// attribute for checkPageValidity()'s native-field scan to find,
			// so an untouched card field was invisible to page validation
			// entirely. Tracked from the card element's own "change" event
			// (see renderStripe()) and checked explicitly in
			// checkPageValidity(). Starts false: an untouched field is not
			// complete.
			this.cardComplete = false;

			// Loading Screen (on /give/ pages or whatever uses the minimal.twig template)
			this.loadingScreens = document.querySelectorAll(`.jsGivePageLoadingScreen`);
			this.loadingScreens.forEach(loadingScreen => {
				loadingScreen.classList.add('-loaded');
			});

			// Captcha
			if ( this.form.dataset.formLocation == 'sidebar' )
			{
				this.donationCaptchaResponse = document.getElementById('sidebar-donation-captcha-response');
			}
			else
			{
				this.donationCaptchaResponse = document.getElementById('main-donation-captcha-response');
			}

			// Overlay
			this.overlay = this.dfc.querySelector('.jsOverlay');
			this.overlayHeading = this.dfc.querySelector('.jsOverlayHeading');
			this.overlayText = this.dfc.querySelector('.jsOverlayText');
			this.overlayProgressLabel = this.dfc.querySelector('.jsOverlayProgressLabel');
			this.overlayProgressBar = this.dfc.querySelector('.jsOverlayProgressBar');
			this.overlayClose = this.dfc.querySelector('.jsOverlayClose');
			this.overlayRetry = this.dfc.querySelector('.jsOverlayRetry');

			// Stripe needs access to some fields
			this.stripeRendered = false;
			this.cc_first_name = this.dfc.querySelector(`#${this.ns}cc_first_name`);
			this.cc_last_name = this.dfc.querySelector(`#${this.ns}cc_last_name`);
			this.address = this.dfc.querySelector(`#${this.ns}address`);
			this.city = this.dfc.querySelector(`#${this.ns}city`);
			this.zip = this.dfc.querySelector(`#${this.ns}zip`);
			this.country = this.dfc.querySelector(`#${this.ns}country`);
			// ijmNl only -- null everywhere else (see watchAddressLookup())
			this.huisNummer = this.dfc.querySelector(`#${this.ns}huisNummer`);
			this.toevoeging = this.dfc.querySelector(`#${this.ns}toevoeging`);
			this.state = this.dfc.querySelector(`#${this.ns}state`);
			this.province = this.dfc.querySelector(`#${this.ns}province`);

			// Optional fields (ijmNl only -- see applyOptionalFieldState()).
			// Prayer Partner/Phone/Date of Birth are each a single field+wrapper;
			// Address is one Hidden/Shown/Required setting governing a whole
			// block of fields together (Toevoeging excepted -- never required).
			this.prayerPartnerField = this.dfc.querySelector('.jsPrayerPartnerField');
			this.prayerPartnerWrapper = this.dfc.querySelector('.jsPrayerPartnerWrapper');
			this.phoneField = this.dfc.querySelector('.jsPhoneField');
			this.phoneWrapper = this.dfc.querySelector('.jsPhoneWrapper');
			this.phoneLabel = this.dfc.querySelector('.jsPhoneLabel');
			this.phoneOptOutField = this.dfc.querySelector('.jsPhoneOptOutField');
			this.phoneOptOutWrapper = this.dfc.querySelector('.jsPhoneOptOutWrapper');
			this.dobField = this.dfc.querySelector('.jsDobField');
			this.dobWrapper = this.dfc.querySelector('.jsDobWrapper');
			this.dobLabel = this.dfc.querySelector('.jsDobLabel');
			this.addressWrapper = this.dfc.querySelector('.jsAddressWrapper');
			this.addressFields = this.dfc.querySelectorAll('.jsAddressField');
			this.addressRequiredFields = this.dfc.querySelectorAll('.jsAddressRequiredField');
			this.addressLabels = this.dfc.querySelectorAll('.jsAddressLabel');
			this.applyOptionalFieldState(this.defaultRecurrence);

			this.bankBtn = this.dfc.querySelector(`#${this.ns}linkButton`);

			// "Ik doneer als" / Organization name (ijmNl only -- null everywhere else)
			this.donateAsField = this.dfc.querySelector(`#${this.ns}donate_as`);
			this.orgNameWrapper = this.dfc.querySelector('.jsOrgNameWrapper');
			this.orgNameLabel = this.dfc.querySelector('.jsOrgNameLabel');

			if ( this.form.dataset.inHonorOf )
			{
				this.showInHonorOfText();
			}

			// Unique ID for SFMC early-lead upsert across all stage writes (primary key in DE).
			this.leadId = this.getQueryOrCookieParam('lead_id') || this.generateLeadId();

			// SFMC tracking params sourced from query string with cookie fallback.
			this.sfmcTracking = {
				sfmc_sub : this.getQueryOrCookieParam('sfmc_sub'),
				j        : this.getQueryOrCookieParam('j'),
				l        : this.getQueryOrCookieParam('l'),
				u        : this.getQueryOrCookieParam('u'),
				jb       : this.getQueryOrCookieParam('jb'),
				mid      : this.getQueryOrCookieParam('mid'),
			};

			// Show donation type selection
			this.renderHiddenFields();
			this.renderRecurrence();
			this.renderContents();
			this.renderSuggestedAmounts();
			this.applyUrlPrefillFields();
			this.toggleStateField();
			//this.renderStripe();
			this.updateDonationSummaryAmount();

			// Watch for various changes
			this.watchFields();
			this.watchNameFields();
			this.watchRecurrenceButtons();
			this.watchSuggestedAmounts();
			this.watchPredefinedAmountButtons();
			this.watchAmountField();
			this.watchTransactionFeesField();
			this.watchPaymentMethodFields();
			this.watchDonateAsField();
			this.watchPaginationControls();
			this.watchMailcheckFields();
			this.watchSuggestedEmails();
			this.watchSuggestedEmailCloseButton();
			this.watchCountry();
			this.watchAddressLookup();
			this.watchPhoneOptOut();
			this.watchBankClick();
			this.watchFormSubmit();
			this.watchModalTrigger();
			this.watchFormVisibility();

		} // init()

		// Load reCAPTCHA once the donor actually sees the form: immediately for
		// a directly-embedded form (e.g. the main /give page), or once the
		// enclosing dialog (e.g. the sidebar "Give" drawer) is opened.
		watchModalTrigger()
		{
			const dialog = this.form.closest('dialog');

			// Fire-and-forget preload in all 3 branches below -- a failure
			// here is silently swallowed (aside from a debug-mode log) on
			// purpose. This is just a warm-up so the token fetch at actual
			// submit time is fast; getRecaptchaToken() (called from the
			// submit handler) already retries the load from scratch and
			// surfaces a real failure via showRecaptchaFailure(). Without
			// catching it here, a blocked/failed preload -- which
			// loadRecaptcha() now correctly rejects instead of hanging
			// forever -- surfaced as a spurious "Uncaught (in promise)"
			// console error with no user-facing effect at all.
			const preloadRecaptcha = () => loadRecaptcha().catch((error) => {
				if (showDebug) console.warn('reCAPTCHA preload failed (will retry at submit time):', error);
			});

			if ( !dialog )
			{
				preloadRecaptcha();
				return;
			}

			if ( dialog.hasAttribute('open') )
			{
				preloadRecaptcha();
				return;
			}

			const observer = new MutationObserver(() => {
				if ( dialog.hasAttribute('open') )
				{
					preloadRecaptcha();
					observer.disconnect();
				}
			});
			observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
		}

	/*
		----------------------------------------------------------------------
			GA4 donation funnel
		----------------------------------------------------------------------
		Pushes GA4 ecommerce events to the dataLayer for GTM to forward:
		view_item -> begin_checkout -> add_payment_info. The final step,
		purchase, is pushed on the thank-you page by the GTM tag
		"Donation - dataLayer Push", which reads the context saved by
		saveTrackingContext() so all four steps can be split by placement.
		Item naming (donation_one_time / _monthly / _annual) must stay in
		sync with that GTM tag, or item reports won't line up.
	*/

		// Where this form instance lives. Standalone donation pages are the
		// donationPages section (uriFormat give/{slug}) -- same heuristic as
		// isOnGivePage() in popups.js.
		getTrackingContext()
		{
			const dialog = this.form.closest('dialog');
			let placement = 'embedded';
			if (this.form.dataset.formLocation === 'sidebar') placement = 'drawer';
			else if (dialog) placement = 'popup';
			else if (window.location.pathname.startsWith('/give/')) placement = 'donation_page';

			const freqMap = { single: 'one_time', monthly: 'monthly', annual: 'annual' };
			const recurrence = this.form.dataset.recurrence;

			return {
				form_placement: placement,
				form_name: this.dfc.dataset.widgetName || '',
				form_id: this.dfc.id,
				donation_frequency: freqMap[recurrence] || recurrence || 'unknown',
			};
		}

		// At most once per event per form instance per page load, so
		// Back/Continue toggling doesn't inflate the funnel.
		trackFunnelStep(eventName)
		{
			this.trackedSteps = this.trackedSteps || new Set();
			if (this.trackedSteps.has(eventName)) return;
			this.trackedSteps.add(eventName);

			const context = this.getTrackingContext();
			const value = parseFloat(this.totalAmountField?.value) || 0;
			const currency = { ijmUs: 'USD', ijmCa: 'CAD', ijmNl: 'EUR' }[allFormSettings.site_handle] || 'USD';
			const freq = context.donation_frequency;

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({ ecommerce: null });
			window.dataLayer.push({
				event: eventName,
				...context,
				ecommerce: {
					value: value,
					currency: currency,
					items: [{
						item_id: 'donation_' + freq,
						item_name: 'Donation (' + freq + ')',
						item_category: freq,
						price: value,
						quantity: 1,
					}],
				},
			});
		}

		// view_item means "the donor saw the form", not "the form rendered":
		// the drawer's form is in the DOM on every page.
		watchFormVisibility()
		{
			const dialog = this.form.closest('dialog');

			if ( dialog )
			{
				if ( dialog.hasAttribute('open') )
				{
					this.trackFunnelStep('view_item');
					return;
				}

				const observer = new MutationObserver(() => {
					if ( dialog.hasAttribute('open') )
					{
						this.trackFunnelStep('view_item');
						observer.disconnect();
					}
				});
				observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
				return;
			}

			// Fires once the top of the form is a quarter of the way up the
			// viewport. A ratio threshold would never fire for a form taller
			// than the screen, which is most of them on mobile.
			const observer = new IntersectionObserver((entries) => {
				if ( entries.some(entry => entry.isIntersecting) )
				{
					this.trackFunnelStep('view_item');
					observer.disconnect();
				}
			}, { rootMargin: '0px 0px -25% 0px' });
			observer.observe(this.dfc);
		}

		// Called on a successful donation, just before the redirect: hands
		// this form's context to the thank-you page's purchase event.
		saveTrackingContext()
		{
			try
			{
				sessionStorage.setItem('ijmDonationContext', JSON.stringify(this.getTrackingContext()));
			}
			catch (e)
			{
				// Storage blocked (some private browsing modes): purchase
				// just reports form_placement "unknown".
			}
		}

		isNumber(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		}

		// IJM Netherlands URL prefill, part 1: things that live in the settings,
		// applied before the form renders. Runs right after defaultRecurrence is
		// read, so ?frequency= can change it and ?amount= targets the recurrence
		// the donor will actually see first.
		applyUrlPrefillSettings()
		{
			const p = this.urlPrefill;
			if (!p) return;

			// Start on the requested recurrence, if this form offers it.
			if (p.frequency && this.recurrenceTypes[p.frequency])
			{
				this.defaultRecurrence = p.frequency;
			}

			// Suggested amount buttons and the amount to start with.
			const amounts = this._settings.amounts;
			if (amounts)
			{
				if (p.singleAmounts)  amounts.suggestedSingleAmounts  = p.singleAmounts;
				if (p.monthlyAmounts) amounts.suggestedMonthlyAmounts = p.monthlyAmounts;
				if (p.annualAmounts)  amounts.suggestedAnnualAmounts  = p.annualAmounts;
				if (p.amount !== null) amounts.defaultAmounts[this.defaultRecurrence] = p.amount;
			}

			// Campaign ID: overrides the one set on the widget (a Salesforce campaign).
			if (p.campaign)
			{
				const campaignField = (this._settings.hiddenFields || []).find(f => f.name === 'campaign_id');
				if (campaignField) campaignField.value = p.campaign;
			}
		}

		// IJM Netherlands URL prefill, part 2: the donor's details. Assigned as
		// input values only (never as HTML), cut to each field's maxlength, and
		// never over something the donor has already typed.
		applyUrlPrefillFields()
		{
			const p = this.urlPrefill;
			if (!p) return;

			[
				['email', p.email],
				['billing_first_name', p.firstName],
				['billing_last_name_prefix', p.lastNamePrefix],
				['billing_last_name', p.lastName],
			].forEach(([name, value]) => {
				if (!value) return;
				this.form.querySelectorAll(`input[name="${name}"]`).forEach(input => {
					if (input.value) return;
					input.value = input.maxLength > 0 ? value.slice(0, input.maxLength) : value;
				});
			});
		}

		getQueryOrCookieParam(name)
		{
			const url = new URLSearchParams(window.location.search);
			if (url.has(name)) return url.get(name);
			const match = document.cookie.match(
				new RegExp('(?:^|; )' + name.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1') + '=([^;]*)')
			);
			return match ? decodeURIComponent(match[1]) : null;
		}

		generateLeadId()
		{
			if (globalThis.crypto && typeof globalThis.crypto.randomUUID === 'function') {
				return globalThis.crypto.randomUUID();
			}

			if (globalThis.crypto && typeof globalThis.crypto.getRandomValues === 'function') {
				const bytes = new Uint8Array(16);
				globalThis.crypto.getRandomValues(bytes);
				bytes[6] = (bytes[6] & 0x0f) | 0x40;
				bytes[8] = (bytes[8] & 0x3f) | 0x80;
				const hex = [...bytes].map(b => b.toString(16).padStart(2, '0')).join('');
				return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
			}

			const now = Date.now().toString(16);
			const rand = Math.random().toString(16).slice(2, 14).padEnd(12, '0');
			return `${now.slice(-8)}-${rand.slice(0, 4)}-4${rand.slice(4, 7)}-a${rand.slice(7, 10)}-${rand.slice(10, 12)}${now}`;
		}

		renderHiddenFields()
		{
			this._settings.hiddenFields.forEach(fieldData => {
				let hiddenField = document.createElement('input');
				hiddenField.type = 'hidden';
				hiddenField.name = fieldData.name;
				hiddenField.value = fieldData.value;
				this.hiddenFields.appendChild(hiddenField);
			});
		}
		// Helper to normalize and apply classes
		applyClasses(el, classes) {
			if (!classes) return;
			const list = Array.isArray(classes)
				? classes.flatMap(cls => cls.split(' '))
				: classes.split(' ');
			el.classList.add(...list);
		};

		// Utility to create radio buttons
		createRadio(settings)
		{
			// Create field wrapper
			let fieldWrapper = document.createElement('div');
			this.applyClasses(fieldWrapper, settings.wrapperClass);
			settings.parent.appendChild(fieldWrapper);
			// Create the radio Field
			let field = document.createElement('input');
			field.type = 'radio';
			field.name = settings.name;
			field.value = settings.value;
			field.id = settings.id;
			field.checked = settings.checked;
			this.applyClasses(field, settings.inputClass);
			fieldWrapper.appendChild(field);
			// Create the label
			let label = document.createElement('label');
			label.setAttribute('for', field.id);
			label.innerHTML = settings.labelText;
			this.applyClasses(label, settings.labelClass);
			fieldWrapper.appendChild(label);
		}

		// For handling errors
		handleError(err_msg)
		{
			// No-op if the bank button was never the thing loading (e.g. a
			// card-flow or final-submit error) -- setBankButtonLoading()
			// guards on this.bankBtn and just re-clears an already-cleared
			// state otherwise.
			this.setBankButtonLoading(false);
			this.logDonationError(err_msg);
			this.handleAppDonateResponse(this, setError(err_msg));
		}

		// Fire-and-forget log of this error for pattern analysis (see
		// log-donation-error.php) -- added after past silent-fail bugs cost
		// real donations with no way to detect them after the fact.
		// Extracts the "(Error-XXX)" code every handleError() call is
		// already tagged with; silently no-ops if the message doesn't have
		// one (an unclassified/unexpected JS error, not one of the known
		// failure modes this is meant to track).
		logDonationError(err_msg)
		{
			const match = /\(Error-([A-Z0-9]+)\)/.exec(String(err_msg));
			if (!match) return;

			const payload = {
				error_code: match[1],
				message: String(err_msg).slice(0, 1000),
				email: this.dfc.querySelector('input[name="email"]')?.value || '',
				amount: this.totalAmountField?.value || '',
				frequency: this.form?.dataset.recurrence || '',
				payment_method: this.form?.dataset.paymentMethod || '',
				site_handle: allFormSettings.site_handle || '',
			};

			fetch('/make-gift/log-donation-error.php', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Donation-Log-Key': allFormSettings.donation_error_log_key,
				},
				body: JSON.stringify(payload),
			}).then((res) => {
				if (!res.ok && showDebug) {
					console.error(`logDonationError(${match[1]}): HTTP ${res.status}`);
				}
			}).catch((error) => {
				if (showDebug) console.error(`logDonationError(${match[1]}):`, error);
			});
		}

		// reCAPTCHA can fail to load/execute for reasons that often clear up
		// on a second attempt (ad blockers, privacy extensions, a flaky
		// network blip, a transient Google hiccup) -- so this shows a Retry
		// button instead of routing through the generic handleError() path,
		// which only offers Close.
		showRecaptchaFailure(retryFn)
		{
			// No-op if the bank button wasn't the thing loading (this fires
			// for the card flow's check-customer call too).
			this.setBankButtonLoading(false);

			// The check_customer flow (handleStripeClientSecret(), triggered
			// by the "Enter Payment Details" button) never opens the overlay
			// on its own -- only collectBankAccount() and the final submit
			// handler do. Call showOverlay() explicitly (idempotent if
			// already open) so this is visible regardless of which flow hit
			// the reCAPTCHA failure.
			this.showOverlay();
			this.overlayProcessing(false);
			if (allFormSettings.site_handle === 'ijmNl')
			{
				this.setOverlayHeading('Oeps');
				this.setOverlayText("We konden niet verifiëren dat u geen robot bent. Probeer het opnieuw, of neem contact op met contact@ijm.org als het probleem aanhoudt.");
			}
			else
			{
				this.setOverlayHeading('Oops');
				this.setOverlayText("We couldn't verify you're not a robot. Please try again, or contact contact@ijm.org if the problem continues.");
			}
			this.showOverlayRetry(retryFn);
			this.showOverlayClose();
		}

		// The donor closed the Financial Connections popup before finishing
		// (or finished it but instant verification failed), so no bank
		// payment method ever got attached to the PaymentIntent. Not a
		// hard failure -- more like an interruption -- so this offers a
		// one-click Retry (straight back into collectBankAccount(), which
		// rebuilds its payload fresh from the current form each time) as
		// well as Close, rather than routing through the generic
		// handleError() path, which only offers Close.
		handleBankConnectionIncomplete()
		{
			this.logDonationError("Bank connection not completed (Error-ACH5)");

			this.showOverlay();
			this.overlayProcessing(false);
			this.setOverlayHeading('Oops');
			this.setOverlayText("It looks like your bank connection wasn't completed. Please try again to finish connecting your bank account.");
			this.showOverlayRetry(() => this.collectBankAccount());
			this.showOverlayClose();
		}

	/*
	########  ########  ######  ##     ## ########  ########  ######## ##    ##  ######  ########
	##     ## ##       ##    ## ##     ## ##     ## ##     ## ##       ###   ## ##    ## ##
	##     ## ##       ##       ##     ## ##     ## ##     ## ##       ####  ## ##       ##
	########  ######   ##       ##     ## ########  ########  ######   ## ## ## ##       ######
	##   ##   ##       ##       ##     ## ##   ##   ##   ##   ##       ##  #### ##       ##
	##    ##  ##       ##    ## ##     ## ##    ##  ##    ##  ##       ##   ### ##    ## ##
	##     ## ########  ######   #######  ##     ## ##     ## ######## ##    ##  ######  ########
		Recurring Donation Options
		-------------------------------------------------------------
	*/
		// Show recurrence buttons
		renderRecurrence()
		{
			if(showDebug) console.group('renderRecurrence()');

			let gradientBorderCheckboxLabelClasses = [
				'relative',
				'before:absolute before:transition before:duration-300 before:ease-in-out before:-inset-px before:rounded-full before:z-[-2] before:opacity-0 before:bg-gradient-to-r before:from-blue-500 before:to-[#1E38D5] peer-checked:before:opacity-100',
				'after:absolute after:transition after:duration-300 after:ease-in-out after:inset-px after:rounded-full after:z-[-1] after:bg-white peer-checked:after:bg-blue-1',
			];

			// Common settings
			let recurrenceSettings = {
				parent: this.dfc.querySelector('.jsRecurrence'),
				name: 'frequency',
				wrapperClass: ['radioFieldWrapper w-full flex items-stretch gap-4'],
				inputClass: ['jsFrequencyTab peer h-0 w-0 absolute opacity-0 peer'],
				labelClass: [
					'w-full px-3 py-3 sm:px-6 sm:py-5 flex items-center justify-center rounded-full cursor-pointer transition duration-300 ease-in-out',
					'peer-checked:text-blue-500 peer-checked:opacity-95',
					...gradientBorderCheckboxLabelClasses,
				]
			};

			let isNl = allFormSettings.site_handle === 'ijmNl';

			// Single settings
			let singleSettings = Object.assign({}, recurrenceSettings);
			singleSettings.value = 'single';
			singleSettings.id = this.ns + 'tab--single';
			// singleSettings.class = 'jsTabSingle';
			singleSettings.labelText = isNl ? `Eenmalige gift` : `One-Time Gift`;

			// Monthly settings
			let monthlySettings = Object.assign({}, recurrenceSettings);
			monthlySettings.value = 'monthly';
			monthlySettings.id = this.ns + 'tab--monthly';
			// monthlySettings.class = 'jsTabMonthly';
			monthlySettings.labelText = isNl ? `Maandelijkse gift` : `Monthly Gift`;

			// Annual settings
			let annualSettings = Object.assign({}, recurrenceSettings);
			annualSettings.value = 'annually';
			annualSettings.id = this.ns + 'tab--annual';
			// annualSettings.class = 'jsTabAnnual';
			annualSettings.labelText = isNl ? `Jaarlijkse gift` : `Annual Gift`;

			if(showDebug) console.log('this.recurrenceChanged(this.defaultRecurrence)');

			this.recurrenceChanged(this.defaultRecurrence);

			if (this.recurrenceTypes.single)
			{
				// If this is the default recurrence, render it checked
				singleSettings.checked = this.defaultRecurrence == 'single';
				this.createRadio(singleSettings);
			}
			if (this.recurrenceTypes.monthly)
			{
				monthlySettings.checked = this.defaultRecurrence == 'monthly';
				this.createRadio(monthlySettings);
			}
			if (this.recurrenceTypes.annual)
			{
				annualSettings.checked = this.defaultRecurrence == 'annual';
				this.createRadio(annualSettings);
			}
			if(showDebug) console.groupEnd();
		}

		// Watch for clicks on the recurrence buttons
		watchRecurrenceButtons()
		{
			let recurrenceControls = this.dfc.querySelectorAll('.jsFrequencyTab');
			recurrenceControls.forEach(tab => {
				tab.addEventListener('click', () => {
					switch (tab.value) {
						case 'annually':
							this.recurrenceChanged('annual');
							break;

						default:
							this.recurrenceChanged(tab.value);
							break;
					}
				});
			});
		}

		// iDEAL doesn't support recurring donations -- disabled outright for
		// both Monthly and Annual (client asked for Annual to offer the same
		// payment methods as Monthly), and failed over to Automatische
		// incasso (Direct Debit) if it was the checked option, matching
		// ijmnl-www-craft3's own donation form. The radio is already hidden
		// via CSS (group-data-[recurrence=monthly/annual]/form:hidden) too,
		// but a hidden radio can still be the checked one.
		// Data::ensureCleanDataNl() enforces this same rule again
		// server-side.
		//
		// Called both from recurrenceChanged() (the donor switches
		// recurrence) and once at init (the widget's default recurrence
		// itself can be Monthly/Annual, which recurrenceChanged() never
		// runs for on page load).
		syncIdealAvailability(currentRecurrence)
		{
			if (allFormSettings.site_handle !== 'ijmNl') return;

			let idealRadio = this.dfc.querySelector('.jsPaymentMethod[value="ideal"]');
			let directDebitRadio = this.dfc.querySelector('.jsPaymentMethod[value="direct-debit"]');
			if (!idealRadio || !directDebitRadio) return;

			let wasDisabled = idealRadio.disabled;
			idealRadio.disabled = (currentRecurrence === 'monthly' || currentRecurrence === 'annual');

			if (!wasDisabled && idealRadio.disabled && idealRadio.checked)
			{
				// Donor had iDEAL selected and just moved to Monthly/Annual --
				// remember that so it can be restored below if they move back
				// to Single without having picked something else in the
				// meantime.
				this.idealSelectionBeforeRecurringDefault = true;
				directDebitRadio.checked = true;
				directDebitRadio.dispatchEvent(new Event('change'));
			}
			else if (wasDisabled && !idealRadio.disabled && this.idealSelectionBeforeRecurringDefault)
			{
				// Only restore iDEAL if Direct Debit is still selected -- if
				// the donor deliberately switched to Credit Card while on
				// Monthly/Annual, that choice must stick, not get silently
				// overwritten just because they leave Monthly/Annual
				// afterward.
				if (directDebitRadio.checked)
				{
					idealRadio.checked = true;
					idealRadio.dispatchEvent(new Event('change'));
				}
				this.idealSelectionBeforeRecurringDefault = false;
			}
		}

		// Cover Transaction Fees (ijmNl only) is offered for single/one-time
		// gifts only. Disabling isn't enough on its own: a disabled checkbox
		// keeps whatever checked
		// state it had before being disabled (the donor may have checked it
		// while on the Single tab, then switched to Monthly), and
		// donation-form.js reads transactionFeesCheckbox.checked directly
		// (not via FormData, which a disabled field would naturally drop) --
		// so the checked state has to be explicitly cleared too, or a fee
		// could still get silently added to a monthly/annual gift.
		syncFeeCoverAvailability(currentRecurrence)
		{
			if (allFormSettings.site_handle !== 'ijmNl') return;
			if (!this.transactionFeesCheckbox) return;

			let show = (currentRecurrence === 'single');
			this.transactionFeesCheckbox.disabled = !show;
			if (!show)
			{
				this.transactionFeesCheckbox.checked = false;
				this.transactionFeesCheckbox.dispatchEvent(new Event('change'));
			}
		}

		// Prayer Partner/Phone/Date of Birth/Address (ijmNl only) are each
		// independently Hidden/Shown/Required per recurrence, via Dropdown
		// fields on the Donation Widget entry (allFormSettings.optional_fields)
		// -- restores the admin control the old ijmnl-www-craft3 site had
		// (Super Table fields there), which this rebuild had hard-coded
		// instead. "monthly" here also governs Annual, matching every other
		// Monthly/Annual pairing in this form. Called both from
		// recurrenceChanged() and once at init.
		//
		// Visibility can't be CSS/group-data based the way e.g.
		// syncFeeCoverAvailability() is, since an admin can change these
		// settings per entry -- wrapper visibility is toggled directly
		// instead, via Tailwind's own "hidden" utility CLASS rather than the
		// native hidden ATTRIBUTE/property: these wrappers all carry a
		// "flex"/"flex-col" class of their own, and author CSS (Tailwind's
		// .flex { display: flex }) always wins over the user-agent
		// stylesheet's [hidden] { display: none } default regardless of
		// specificity or source order -- confirmed by the exact same problem
		// already solved elsewhere in this codebase (donationWidget.scss's
		// .input--radio&[hidden] override, needed for the same reason).
		// Tailwind's .hidden class, by contrast, is itself an author rule
		// that's proven to correctly override "flex" elsewhere in this file
		// (the recurrence group-data-hidden/flex pattern). CSS display:none
		// does NOT exempt a field from checkValidity() the way a disabled
		// field does (confirmed directly: a required, empty, display:none
		// input still fails checkValidity()), so Required/Hidden fields are
		// also explicitly enabled/disabled here, not just shown/hidden.
		applyOptionalFieldState(currentRecurrence)
		{
			if (allFormSettings.site_handle !== 'ijmNl') return;
			if (!allFormSettings.optional_fields) return;

			let group = (currentRecurrence === 'single') ? 'single' : 'monthly';
			let settings = allFormSettings.optional_fields;

			let setFieldState = (mode, field, wrapper, label = null) =>
			{
				if (!field || !wrapper) return;

				let hidden = (mode === 'hidden');
				let required = (mode === 'required');

				wrapper.classList.toggle('hidden', hidden);
				field.disabled = hidden;
				field.required = required;
				if (label) label.classList.toggle('required', required);
			};

			setFieldState(settings.prayerPartner[group], this.prayerPartnerField, this.prayerPartnerWrapper);

			let phoneMode = settings.phone[group];
			setFieldState(phoneMode, this.phoneField, this.phoneWrapper, this.phoneLabel);
			this.updatePhoneOptOutVisibility();

			setFieldState(settings.dateOfBirth[group], this.dobField, this.dobWrapper, this.dobLabel);

			// Address is one setting governing a whole block of fields
			// together -- Toevoeging is exempt from "required" either way,
			// matching the reference implementation (an address addition is
			// never mandatory).
			let addressMode = settings.address[group];
			if (this.addressWrapper)
			{
				let addressHidden = (addressMode === 'hidden');
				let addressRequired = (addressMode === 'required');

				this.addressWrapper.classList.toggle('hidden', addressHidden);
				this.addressFields.forEach(field => { field.disabled = addressHidden; });
				this.addressRequiredFields.forEach(field => { field.required = addressRequired; });
				this.addressLabels.forEach(label => { label.classList.toggle('required', addressRequired); });
			}
		}

		// Phone opt-out (ijmNl only) is only relevant -- and only shown --
		// once Phone is both available (not Hidden per applyOptionalFieldState()
		// above) and the donor has actually typed a number into it; asking
		// someone to opt out of phone contact before they've given a number
		// at all is meaningless. Called from applyOptionalFieldState() on
		// recurrence change/init, and live on every keystroke in Phone
		// itself (watchPhoneOptOut()) so it reacts as the donor types or
		// clears the field, not just when the recurrence/mode changes.
		updatePhoneOptOutVisibility()
		{
			if (allFormSettings.site_handle !== 'ijmNl') return;
			if (!this.phoneField || !this.phoneOptOutField || !this.phoneOptOutWrapper) return;

			let show = !this.phoneField.disabled && this.phoneField.value.trim() !== '';
			this.phoneOptOutWrapper.classList.toggle('hidden', !show);
			this.phoneOptOutField.disabled = !show;
			if (!show)
			{
				this.phoneOptOutField.checked = false;
				if (this.phoneInfoPopupClose) this.phoneInfoPopupClose();
			}
		}

		// IBAN/Account Holder/Direct Debit consent (ijmNl only) are only
		// required for Direct Debit -- same disabled-not-just-hidden
		// reasoning as applyOptionalFieldState() above, just keyed off
		// payment method instead of recurrence.
		syncDirectDebitOnlyFields(currentPaymentMethod)
		{
			if (allFormSettings.site_handle !== 'ijmNl') return;

			let show = (currentPaymentMethod === 'direct-debit');
			this.dfc.querySelectorAll('.jsDirectDebitOnlyField').forEach(field => {
				field.disabled = !show;
			});
		}

		// Handle changes to the recurrence buttons
		recurrenceChanged(currentRecurrence)
		{
			// If the user toggles the recurrence on a page other than the first one, jump them back to the first page.
			let activePage = this.dfc.querySelector('.jsFormPage.flex');
			if (activePage.id != this.ns + 'form-page--1')
			{
				this.changeToPage(`#${this.ns}form-page--1`);
			}

			this.form.dataset.recurrence = currentRecurrence;

			this.syncIdealAvailability(currentRecurrence);
			this.applyOptionalFieldState(currentRecurrence);
			this.syncFeeCoverAvailability(currentRecurrence);

			// Set amount field minimum
			this.visibleAmountField.setAttribute('min', this.min[currentRecurrence]);

			// Show default amount if field hasn't been altered by the user
			if (!this.amountIsDirty)
			{
				if (this._settings.amounts)
				{
					switch (this._settings.amounts.defaultAmounts[currentRecurrence])
					{
						case 'none':
							this.visibleAmountField.value = '';
							this.totalAmountField.value = '';
							break;

						default:
							this.visibleAmountField.value = this._settings.amounts.defaultAmounts[currentRecurrence];
							this.totalAmountField.value = this._settings.amounts.defaultAmounts[currentRecurrence];
							break;
					}
				}
			}

			// Indicate if the amount matches a suggested amount button
			this.highlightMatchingButtons(this.visibleAmountField.value);

			// IJM Netherlands: donationWidget.twig's "Choose <span>…</span>
			// amount:" label is built from 'Choose'/'amount:' (translated via
			// translations/nl/site.php) around this span, so -- unlike the
			// English side, where the article lives inside the span -- the
			// Dutch article ("een") has to travel with it too, since Dutch
			// adjective agreement differs by what follows ("een maandelijks
			// bedrag" has no -e; this isn't just 1:1 word substitution).
			const isNl = allFormSettings.site_handle === 'ijmNl';

			switch (currentRecurrence) {
				case 'single':
					this.donationRecurrenceText.innerText = isNl ? 'een eenmalig' : 'a one-time';
					// this.donationRecurrenceText.style.display = 'none';
					this.giveButtonTextArr.forEach(button => {
						button.innerText = isNl ? 'Geef' : 'Give One-Time Gift';
					});
					break;
				case 'monthly':
					this.donationRecurrenceText.innerText = isNl ? 'een maandelijks' : 'a monthly';
					// this.donationRecurrenceText.style.display = 'inline';
					this.giveButtonTextArr.forEach(button => {
						button.innerText = isNl ? 'Geef maandelijks' : 'Give Monthly Gift';
					});
					break;
				case 'annual':
					this.donationRecurrenceText.innerText = isNl ? 'een jaarlijks' : 'an annual';
					// this.donationRecurrenceText.style.display = 'inline';
					this.giveButtonTextArr.forEach(button => {
						button.innerText = isNl ? 'Geef jaarlijks' : 'Give Annual Gift';
					});
					break;
				default:
					break;
			}
			// this.updateSuggestedAmountText(currentRecurrence);

			this.updateTransactionFees();
			this.updateDonationSummaryRecurrence(currentRecurrence);

			activePage.querySelectorAll('input, select').forEach(field =>
			{
				this.removeFieldError(field);
				this.hideErrorMessage(field);
			});
		}
	/*
	|  ######   #######  ##    ## ######## ######## ##    ## ########  ######
	| ##    ## ##     ## ###   ##    ##    ##       ###   ##    ##    ##    ##
	| ##       ##     ## ####  ##    ##    ##       ####  ##    ##    ##
	| ##       ##     ## ## ## ##    ##    ######   ## ## ##    ##     ######
	| ##       ##     ## ##  ####    ##    ##       ##  ####    ##          ##
	| ##    ## ##     ## ##   ###    ##    ##       ##   ###    ##    ##    ##
	|  ######   #######  ##    ##    ##    ######## ##    ##    ##     ######
		Contents
		----------------------------------------------------------------------
	*/

		renderContents()
		{
			if (this._settings.formContents)
			{
				this._settings.formContents.forEach(copyBlock => {
					let contentHTML = document.createElement('div');
					contentHTML.className = 'jsTextualContents prose prose-sm xs:prose-base sm:prose-lg prose-headings:font-feijoa prose-headings:mt-0 prose-headings:mb-1 prose-p:mt-1em prose-p:mb-0';
					// let recurrenceClass = '';
					switch (copyBlock.recurrence) {
						case 'all':
							// recurrenceClass = 'block';
							contentHTML.classList.add('block');
							break;
						case 'singleOnly':
							contentHTML.classList.add('hidden','group-data-[recurrence=single]/form:block');
							break;
						case 'monthlyOnly':
							contentHTML.classList.add('hidden','group-data-[recurrence=monthly]/form:block');
							break;
						case 'annualOnly':
							contentHTML.classList.add('hidden','group-data-[recurrence=annual]/form:block');
							break;
					}
					contentHTML.innerHTML = `<h2>${copyBlock.heading}</h2>
					${copyBlock.text}`;

					// let textualContents = document.createElement('div');
					// textualContents.className = 'jsTextualContents prose prose-sm xs:prose-base sm:prose-lg prose-headings:font-feijoa prose-headings:mt-0 prose-headings:mb-1 prose-p:mt-1em prose-p:mb-0';
					// textualContents.appendChild(contentHTML);
					const recurrenceElem = this.dfc.querySelector('.jsRecurrence');
					recurrenceElem?.after(contentHTML);
					// this.dfc.querySelector('.jsTextualContents').appendChild(contentHTML)
				});
			}
		}

		// Show or hide the "Select or " text according to if there are suggested amount buttons for the current recurrence mode.
/* 		updateSuggestedAmountText(currentRecurrence)
		{
			if (this.dfc.querySelector('form[data-recurrence="' + currentRecurrence + '"] .suggestedAmount.-' + currentRecurrence) !== null)
			{
				this.hasSuggestedAmountsText.style.display = 'inline';
			} else {
				this.hasSuggestedAmountsText.style.display = 'none';
			}
		} */

		showInHonorOfText()
		{
			let wordHonor = document.documentElement.lang == 'en-CA' ? 'honour' : 'honor';
			let text = `<p><strong>Want to give in ${wordHonor} of someone you love?</strong> Once you make your donation, send them a personalized eCard!</p>`;
			this.inHonorOfWrapper.classList.replace('hidden', 'block');
			this.inHonorOfWrapper.innerHTML = text;
		}

	/*
	|  ######  ##     ##  ######    ######   ########  ######  ######## ######## ########
	| ##    ## ##     ## ##    ##  ##    ##  ##       ##    ##    ##    ##       ##     ##
	| ##       ##     ## ##        ##        ##       ##          ##    ##       ##     ##
	|  ######  ##     ## ##   #### ##   #### ######    ######     ##    ######   ##     ##
	|       ## ##     ## ##    ##  ##    ##  ##             ##    ##    ##       ##     ##
	| ##    ## ##     ## ##    ##  ##    ##  ##       ##    ##    ##    ##       ##     ##
	|  ######   #######   ######    ######   ########  ######     ##    ######## ########
	|
	|    ###    ##     ##  #######  ##     ## ##    ## ########    ########  ######## ##    ##
	|   ## ##   ###   ### ##     ## ##     ## ###   ##    ##       ##     ##    ##    ###   ##
	|  ##   ##  #### #### ##     ## ##     ## ####  ##    ##       ##     ##    ##    ####  ##
	| ##     ## ## ### ## ##     ## ##     ## ## ## ##    ##       ########     ##    ## ## ##
	| ######### ##     ## ##     ## ##     ## ##  ####    ##       ##     ##    ##    ##  ####
	| ##     ## ##     ## ##     ## ##     ## ##   ###    ##       ##     ##    ##    ##   ###
	| ##     ## ##     ##  #######   #######  ##    ##    ##       ########     ##    ##    ##
		Suggested Amount buttons
		-------------------------------------------------------------
		Render the suggested amount buttons for each recurrence (if any were specified in the template). Each set of buttons for a recurrence is wrapped in its own wrapper, which is also generated on the fly.
	*/
		renderSuggestedAmounts()
		{
			if (this._settings.amounts)
			{

				let gradientBorderButtonClasses = [
					'relative z-10',
					'before:absolute before:transition before:duration-300 before:ease-in-out before:-inset-px before:rounded-full before:z-[-2] before:opacity-0 before:bg-gradient-to-r before:from-blue-500 before:to-[#1E38D5] [&.active]:before:opacity-100',
					'after:absolute after:transition after:duration-300 after:ease-in-out after:inset-0 after:rounded-full after:z-[-1] after:bg-white [&.active]:after:bg-blue-1 [&.active]:after:inset-px',
				];
				let amounts = this._settings.amounts;
				let suggestedAmountsWrapperClasses = [
					'suggestedAmounts hidden flex-wrap gap-3 items-center justify-center text-gray-600',
				];
				let amountButtonClasses = [
					'suggestedAmount jsSuggestedAmount',
					'basis-[30%] flex-auto px-8 py-2 border border-black/50 rounded-full cursor-pointer font-normal text-2xl max-w-[170px] transition',
					'[&.active]:text-blue-500 [&.active]:font-medium [&.active]:border-transparent',
					...gradientBorderButtonClasses,
				];
				let isNl = allFormSettings.site_handle === 'ijmNl';
				let currencySymbol = isNl ? '€' : '$';

				// Single
				if (amounts.suggestedSingleAmounts.length)
				{
					// Create the wrapper
					let suggestedSingleAmountsWrapper = document.createElement('div');
					this.applyClasses(suggestedSingleAmountsWrapper, [...suggestedAmountsWrapperClasses, 'group-data-[recurrence=single]/form:flex', '-numAmounts-'+amounts.suggestedSingleAmounts.length]);

					// Create the buttons
					amounts.suggestedSingleAmounts.forEach(amnt => {
						let btn = document.createElement('button');
						btn.value = amnt;
						btn.innerText = currencySymbol + amnt.toLocaleString();
						btn.type = 'button';
						this.applyClasses(btn, ['-single', ...amountButtonClasses]);
						suggestedSingleAmountsWrapper.appendChild(btn);
					});

					this.amountWrapper.before(suggestedSingleAmountsWrapper);
				}
				// Monthly
				if (amounts.suggestedMonthlyAmounts.length)
				{
					let suggestedMonthlyAmountsWrapper = document.createElement('div');
					this.applyClasses(suggestedMonthlyAmountsWrapper, [...suggestedAmountsWrapperClasses, 'group-data-[recurrence=monthly]/form:flex', '-numAmounts-'+amounts.suggestedMonthlyAmounts.length]);

					amounts.suggestedMonthlyAmounts.forEach(amnt => {
						let btn = document.createElement('button');
						btn.value = amnt;
						btn.innerHTML = currencySymbol + amnt.toLocaleString() + '<span class="text-sm">' + (isNl ? '/mnd' : '/mo') + '</span>';
						btn.type = 'button';
						this.applyClasses(btn, ['-monthly', ...amountButtonClasses]);
						suggestedMonthlyAmountsWrapper.appendChild(btn);
					});

					this.amountWrapper.before(suggestedMonthlyAmountsWrapper);
				}

				// Annual
				if (amounts.suggestedAnnualAmounts.length)
				{
					let suggestedAnnualAmountsWrapper = document.createElement('div');
					this.applyClasses(suggestedAnnualAmountsWrapper, [...suggestedAmountsWrapperClasses, 'group-data-[recurrence=annual]/form:flex', '-numAmounts-'+amounts.suggestedAnnualAmounts.length]);

					amounts.suggestedAnnualAmounts.forEach(amnt => {
						let btn = document.createElement('button');
						btn.value = amnt;
						btn.innerHTML = currencySymbol + amnt.toLocaleString() + '<span class="text-sm">' + (isNl ? '/jr' : '/yr') + '</span>';
						btn.type = 'button';
						this.applyClasses(btn, ['-annual', ...amountButtonClasses]);
						suggestedAnnualAmountsWrapper.appendChild(btn);
					});

					this.amountWrapper.before(suggestedAnnualAmountsWrapper);
				}

				// this.updateSuggestedAmountText(this.defaultRecurrence);

				// Indicate if the amount matches a suggested amount button
				this.highlightMatchingButtons(this.visibleAmountField.value);
			}
		}

		resetSelectedAmountButton()
		{
			let amountBtns = this.dfc.querySelectorAll('.jsSuggestedAmount');
			amountBtns.forEach(btn => {
				btn.classList.remove('active');
			});
		}

		watchSuggestedAmounts()
		{
			let amountBtns = this.dfc.querySelectorAll('.jsSuggestedAmount');
			amountBtns.forEach(btn => {
				btn.addEventListener('click', () => {
					this.resetSelectedAmountButton();
					btn.classList.add('active');
					this.visibleAmountField.value = btn.value;
					// Trigger a change event when the value is updated programmatically.
					this.visibleAmountField.dispatchEvent(new Event('change'));
					this.checkFieldValidity(this.visibleAmountField);
				});
			});
		}

	/*
	|    ###    ##     ##  #######  ##     ## ##    ## ########
	|   ## ##   ###   ### ##     ## ##     ## ###   ##    ##
	|  ##   ##  #### #### ##     ## ##     ## ####  ##    ##
	| ##     ## ## ### ## ##     ## ##     ## ## ## ##    ##
	| ######### ##     ## ##     ## ##     ## ##  ####    ##
	| ##     ## ##     ## ##     ## ##     ## ##   ###    ##
	| ##     ## ##     ##  #######   #######  ##    ##    ##
		Amount field
		----------------------------------------------------------------------

	*/
		watchAmountField()
		{
			// Truncate to at most 2 decimal places as the donor types,
			// rather than letting more through and flagging it as an error
			// afterward -- type="number" doesn't restrict decimal-place
			// count on its own (only step-alignment, which is a separate
			// concern here; see isValidIgnoringStepMismatch()).
			this.visibleAmountField.addEventListener('input', (e) =>
			{
				let parts = e.target.value.split('.');
				if (parts.length > 1 && parts[1].length > 2)
				{
					e.target.value = parts[0] + '.' + parts[1].slice(0, 2);
				}
			});

			// When input amount changes
			this.visibleAmountField.addEventListener('change', (e) =>
			{
				// Mark the amount field as having been changed by the user, so we don't reset it to any defaults from here on out.
				this.amountIsDirty = true;

				// Get provided amount, formatted to exactly 2 decimal places
				// (the 'input' listener above already caps it at 2, but e.g.
				// a whole-dollar "25" still needs padding to "25.00")
				this.targetAmount = parseFloat(e.target.value).toFixed(2);

				// Write the formatted value back into the visible field
				// itself, not just the hidden total, so what's displayed
				// always matches what's actually submitted.
				e.target.value = this.targetAmount;

				// Keep amount field that actually gets submitted in sync with visible amount
				this.totalAmountField.value = this.targetAmount;

				// If we're covering fees, apply fees to the total amount field
				this.updateTransactionFees();

				// Update the amount shown in the donation summary
				this.updateDonationSummaryAmount();

				// Mark any suggested amount buttons that match the value in the amount field.
				this.highlightMatchingButtons(this.targetAmount);

			});
		}

		// A Give Button's "Predefined Amount" and "Opens On" settings arrive as
		// data-amount / data-frequency on the button that opens this flyout
		// (buttonLink.twig, IJM Netherlands). Recurrence first -- switching it can
		// reset the amount to that recurrence's default -- then the amount, through
		// the amount field's own 'change' path, so the total, fees, summary and the
		// matching suggested-amount button update as if the donor had typed it.
		// The donor can still change both.
		applyPredefinedRecurrence(frequency)
		{
			const key = frequency === 'annually' ? 'annual' : frequency;
			if (!['single', 'monthly', 'annual'].includes(key)) return;
			// Only if this form offers that recurrence.
			if (!this.recurrenceTypes[key]) return;

			const tab = this.dfc.querySelector('.jsFrequencyTab[value="' + (key === 'annual' ? 'annually' : key) + '"]');
			if (tab) tab.click();
			else this.recurrenceChanged(key);
		}

		applyPredefinedAmount(amount)
		{
			const n = parseFloat(amount);
			if (!isFinite(n) || n <= 0 || n > 250000) return;
			this.visibleAmountField.value = n;
			this.visibleAmountField.dispatchEvent(new Event('change'));
		}

		watchPredefinedAmountButtons()
		{
			// Only the flyout form is opened by Give Buttons.
			if (this.form.dataset.formLocation !== 'sidebar') return;

			document.addEventListener('click', (e) => {
				const giveButton = e.target.closest ? e.target.closest('[data-dialog-id="popup--give"]') : null;
				if (!giveButton) return;
				if (giveButton.dataset.frequency) this.applyPredefinedRecurrence(giveButton.dataset.frequency);
				if (giveButton.dataset.amount) this.applyPredefinedAmount(giveButton.dataset.amount);
			});
		}

		// Check if any suggested amount buttons match and highlight them.
		highlightMatchingButtons(amount)
		{
			let matchingButtons = this.dfc.querySelectorAll('.jsSuggestedAmount[value="' + parseFloat(amount).toFixed(0) + '"]');
			if (matchingButtons) {
				this.resetSelectedAmountButton();
				matchingButtons.forEach(btn => {
					btn.classList.add('active');
				});
			}
		}
	/*
	| ######## ########     ###    ##    ##  ######     ###     ######  ######## ####  #######  ##    ##
	|    ##    ##     ##   ## ##   ###   ## ##    ##   ## ##   ##    ##    ##     ##  ##     ## ###   ##
	|    ##    ##     ##  ##   ##  ####  ## ##        ##   ##  ##          ##     ##  ##     ## ####  ##
	|    ##    ########  ##     ## ## ## ##  ######  ##     ## ##          ##     ##  ##     ## ## ## ##
	|    ##    ##   ##   ######### ##  ####       ## ######### ##          ##     ##  ##     ## ##  ####
	|    ##    ##    ##  ##     ## ##   ### ##    ## ##     ## ##    ##    ##     ##  ##     ## ##   ###
	|    ##    ##     ## ##     ## ##    ##  ######  ##     ##  ######     ##    ####  #######  ##    ##
	|
	| ######## ######## ########  ######
	| ##       ##       ##       ##    ##
	| ##       ##       ##       ##
	| ######   ######   ######    ######
	| ##       ##       ##             ##
	| ##       ##       ##       ##    ##
	| ##       ######## ########  ######
		Cover Transaction Fees
		--------------------------------------------------------------
	*/
		// When donor chooses to cover transaction fees
		watchTransactionFeesField()
		{
			this.transactionFeesCheckbox.addEventListener('change', () => {

				this.updateTransactionFees();

				// Update the amount shown in the donation summary
				this.updateDonationSummaryAmount();
			});
		}

		updateTransactionFees()
		{
			// Get provided amount
			this.targetAmount = parseFloat(this.visibleAmountField.value).toFixed(2);
			this.fees = this.calculateFees(this.targetAmount);

			// Update elements that show user what the fees amount is. NL
			// uses a comma decimal separator (matching the "€ 0,25" copy
			// requested for the fee-cover checkbox label); this.fees itself
			// stays a period-formatted numeric string since it also feeds
			// arithmetic below (totalAmountField).
			let displayedFees = (allFormSettings.site_handle === 'ijmNl')
				? this.fees.replace('.', ',')
				: this.fees;
			this.feesAmounts.forEach(el =>
			{
				el.textContent = displayedFees;
			});

			if ( this.isNumber( this.visibleAmountField.value ) && this.visibleAmountField.value > 0 )
			{

				if (this.transactionFeesCheckbox.checked) {
					// this.applyFees(this.targetAmount);
					// If the user has checked the box to cover fees, calculate the total amount
					this.totalAmountField.value = (parseFloat(this.targetAmount) + parseFloat(this.fees)).toFixed(2);

					// Show fees in Donation Summary
					this.summaryCoverFees.forEach(el =>
					{
						el.hidden = false;
					});
				} else {
					// this.removeFees(this.targetAmount);
					// If the user has unchecked the box to cover fees, just set the total amount to the target amount
					this.totalAmountField.value = parseFloat(this.targetAmount);

					// Hide fees in Donation Summary
					this.summaryCoverFees.forEach(el =>
					{
						el.hidden = true;
					});
				}

				// The $250,000 ceiling is enforced server-side against the
				// fee-inclusive total, not the base amount (Data.php's
				// ensureValidAmount()) -- a $250,000 base donation with
				// "cover fees" checked grosses up to $254,842.30 for card
				// payments, which the field's own max="250000" attribute
				// (checked against the base amount only) never catches, so
				// it previously reached client-secret.php and came back as
				// a raw "Error-CSCS3" instead of the same inline
				// validation every other amount problem gets. Reusing
				// setCustomValidity() here -- rather than back-solving a
				// separate max per payment method -- means this always
				// tracks whatever calculateFees() above actually charges,
				// with nothing to keep in sync by hand.
				if ( parseFloat(this.totalAmountField.value) > 250000 )
				{
					let formattedTotal = parseFloat(this.totalAmountField.value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
					this.visibleAmountField.setCustomValidity(
						'Covering fees would bring this donation to $' + formattedTotal + ', over IJM\'s $250,000 maximum. Lower the amount or uncheck "Cover fees" to continue.'
					);
				}
				else
				{
					this.visibleAmountField.setCustomValidity('');
				}
				this.checkFieldValidity(this.visibleAmountField);
			}
			// If there's no number, don't try to calculate fees
			else
			{
				// Update elements that show user what the fees amount is
				this.feesAmounts.forEach(el =>
				{
					el.textContent = '0.00';
				});
				// this.removeFees(this.visibleAmountField.value);

				// No valid amount to evaluate the fee-inclusive ceiling
				// against -- clear any stale custom error left over from a
				// previous amount so it doesn't linger (valueMissing/
				// rangeUnderflow will show instead, as appropriate).
				this.visibleAmountField.setCustomValidity('');
			}
		}

	/*
		--------------------------------------------------------------
			Ik doneer als / Organization Name (ijmNl only)
		--------------------------------------------------------------
	*/
		// Naam bedrijf/kerk/organisatie is only meaningful when the donor isn't
		// giving as an individual -- show/hide it and swap its label to match
		// whichever non-individual option is selected.
		watchDonateAsField()
		{
			// Not present outside ijmNl
			if ( !this.donateAsField ) return;

			this.donateAsField.addEventListener('change', () => this.updateOrgNameField());

			// Set the correct state on load too (e.g. the field can come back
			// pre-filled with a non-default value after a validation error or
			// browser back/forward navigation).
			this.updateOrgNameField();
		}

		updateOrgNameField()
		{
			if ( !this.donateAsField || !this.orgNameWrapper ) return;

			const labels = {
				bedrijf: 'Naam bedrijf',
				kerk: 'Naam kerk',
				organisatie: 'Naam organisatie',
			};

			const label = labels[this.donateAsField.value];

			// The `hidden` IDL property/attribute alone would NOT be enough
			// here: the UA stylesheet's `[hidden] { display: none }` default
			// has no `!important` and is author-overridable, so this
			// fieldset's own `flex`/`flex-col` classes (from
			// fieldWrapperClasses) win over it regardless of specificity or
			// source order -- confirmed directly against this form's actual
			// compiled CSS (and the identical problem already solved
			// elsewhere in this codebase, donationWidget.scss's
			// `.input--radio&[hidden]` override). The inline `display` set
			// directly below is what actually does the hiding; `.hidden` is
			// set alongside it only for consistency with the rest of this
			// file's hidden-state fields.
			if ( label )
			{
				this.orgNameWrapper.hidden = false;
				this.orgNameWrapper.style.display = '';
				if ( this.orgNameLabel ) this.orgNameLabel.textContent = label;
			}
			else
			{
				// "particulier" (or anything unrecognized) -- not applicable
				this.orgNameWrapper.hidden = true;
				this.orgNameWrapper.style.display = 'none';
			}
		}

		calculateFees(targetAmount)
		{
			// The fees calculation differs depending on which give mode is selected
			if (allFormSettings.site_handle === 'ijmNl')
			{
				// Findock/Buckaroo has no per-transaction flat-fee component
				// the way Stripe does. iDEAL and Direct Debit (Automatische
				// incasso) are bank-to-bank rails with a flat EUR0.25
				// fee-cover option regardless of amount (matching
				// AppDonateNl.php's buildFindockPayload()); Credit Card
				// carries real interchange/scheme fees, so it stays a flat
				// 1.8% of the target amount. This is deliberately NOT the US
				// grossed-up formula below (solving totalCharged - cut =
				// target) -- the backend derives the reported fee back out
				// of the already-submitted total via total - total/1.018,
				// which only reconciles to this exact value if this is a
				// straight percentage of the target amount, not a
				// grossed-up solve.
				if (this.paymentMethod == 'ideal' || this.paymentMethod == 'direct-debit')
				{
					var fees = parseFloat(0.25).toFixed(2);
				}
				else
				{
					var fees = (parseFloat(targetAmount) * 0.018).toFixed(2);
				}
			}
			else if (this.paymentMethod == 'bank')
			{
				// ACH/bank has a flat 40 cent fee
				var fees = parseFloat(0.4).toFixed(2);
			}
			else
			{
				// Credit Card: Stripe takes (totalCharged * rate + flat) out of
				// whatever the donor is actually charged. To fully cover that
				// -- so IJM nets exactly targetAmount -- the fee-to-charge has
				// to be grossed up (solving totalCharged - stripeCut =
				// targetAmount for totalCharged), not just estimated as
				// (targetAmount + flat) * rate + flat, which undercharges by
				// a growing amount as targetAmount increases (confirmed
				// against a real transaction: $1,000 intended -> that formula
				// only nets $999.64).
				const rate = 0.019;
				const flat = 0.3;
				var fees = ( ( parseFloat(targetAmount) * rate + flat ) / ( 1 - rate ) ).toFixed(2);
			}
			return fees;
		}

		/**
		 *
		 * @param {Number} targetAmount This is the original amount the
		 * donor intended to give, before covering transaction fees.
		 */
/* 		applyFees(targetAmount)
		{
			let fees = this.calculateFees(targetAmount);

			// yes, 0.3 needs to be here twice since we're calculating the FEES, not the new TOTAL.
			let newAmount = (parseFloat(targetAmount) + parseFloat(fees)).toFixed(2);

			// Update elements that show user what the fees amount is
			this.feesAmounts.forEach(el =>
			{
				el.textContent = fees;
			});

			// Update field that actually gets submitted
			this.totalAmountField.value = newAmount;

			// Show fees in Donation Summary
			this.summaryCoverFees.forEach(el =>
			{
				el.classList.add('-shown');
			});
		} */

		/**
		 *
		 * @param {Number} targetAmount This is the original amount the donor
		 * intended to give, before covering transaction fees.
		 */
/* 		removeFees(targetAmount)
		{
			// this.feesAmount.innerHTML = '';
			// this.feesAmounts.forEach(el =>
			// {
			// 	el.textContent = '';
			// });
			this.totalAmountField.value = targetAmount;

			// Hide fees in Donation Summary
			this.summaryCoverFees.forEach(el =>
			{
				el.classList.remove('-shown');
			});
		} */

	/*
	| ########     ###    ##    ## ##     ## ######## ##    ## ########
	| ##     ##   ## ##    ##  ##  ###   ### ##       ###   ##    ##
	| ##     ##  ##   ##    ####   #### #### ##       ####  ##    ##
	| ########  ##     ##    ##    ## ### ## ######   ## ## ##    ##
	| ##        #########    ##    ##     ## ##       ##  ####    ##
	| ##        ##     ##    ##    ##     ## ##       ##   ###    ##
	| ##        ##     ##    ##    ##     ## ######## ##    ##    ##
	|
	| ##     ## ######## ######## ##     ##  #######  ########
	| ###   ### ##          ##    ##     ## ##     ## ##     ##
	| #### #### ##          ##    ##     ## ##     ## ##     ##
	| ## ### ## ######      ##    ######### ##     ## ##     ##
	| ##     ## ##          ##    ##     ## ##     ## ##     ##
	| ##     ## ##          ##    ##     ## ##     ## ##     ##
	| ##     ## ########    ##    ##     ##  #######  ########
	*/

		watchPaymentMethodFields()
		{
			// Watch for changes to the payment method radio buttons
			this.paymentMethodFields.forEach(field => {
				field.addEventListener('change', (event) => {
					this.handlePaymentMethodChange(event);
				});
			});
		}

		handlePaymentMethodChange(event)
		{
			// Set the paymentMethod var
			this.paymentMethod = event.target.value;
			this.form.dataset.paymentMethod = this.paymentMethod;
			if(showDebug) console.log('Payment method changed to: ' + this.paymentMethod);
			this.syncDirectDebitOnlyFields(this.paymentMethod);
			this.updateTransactionFees();
		}


	/*
	| ########   #######  ##    ##    ###    ######## ####  #######  ##    ##
	| ##     ## ##     ## ###   ##   ## ##      ##     ##  ##     ## ###   ##
	| ##     ## ##     ## ####  ##  ##   ##     ##     ##  ##     ## ####  ##
	| ##     ## ##     ## ## ## ## ##     ##    ##     ##  ##     ## ## ## ##
	| ##     ## ##     ## ##  #### #########    ##     ##  ##     ## ##  ####
	| ##     ## ##     ## ##   ### ##     ##    ##     ##  ##     ## ##   ###
	| ########   #######  ##    ## ##     ##    ##    ####  #######  ##    ##
	|
	|  ######  ##     ## ##     ## ##     ##    ###    ########  ##    ##
	| ##    ## ##     ## ###   ### ###   ###   ## ##   ##     ##  ##  ##
	| ##       ##     ## #### #### #### ####  ##   ##  ##     ##   ####
	|  ######  ##     ## ## ### ## ## ### ## ##     ## ########     ##
	|       ## ##     ## ##     ## ##     ## ######### ##   ##      ##
	| ##    ## ##     ## ##     ## ##     ## ##     ## ##    ##     ##
	|  ######   #######  ##     ## ##     ## ##     ## ##     ##    ##
	*/
		updateDonationSummaryAmount()
		{
			// visibleAmountField is a type="number" input -- its raw .value
			// can never contain a comma (the spec doesn't allow it) and only
			// has decimals if the donor happened to type them, so echoing it
			// straight into the summary showed "$2000" instead of "$2,000.00"
			// -- inconsistent with the fee amount right next to it, which is
			// always formatted to 2 decimals (see updateTransactionFees()).
			// The summary is plain text, not an input, so it's free to be
			// formatted for display without touching the field itself.
			let amount = parseFloat(this.visibleAmountField.value);
			let formatted = isNaN(amount)
				? this.visibleAmountField.value
				: amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
			this.summaryAmounts.forEach(el => {
				el.textContent = formatted;
			});
		}

		// Update the donation summary text with the recurrence (if not a one-time gift)
		updateDonationSummaryRecurrence(mode)
		{
			const isNl = allFormSettings.site_handle === 'ijmNl';

			let text = '';
			switch (mode)
			{
				case 'monthly':
					text = isNl ? ' maandelijks' : ' monthly';
					break;

				case 'annual':
					text = isNl ? ' jaarlijks' : ' annually';
					break;

				default:
					text = '';
					break;
			}
			this.summaryRecurrences.forEach(span =>
			{
				span.textContent = text;
			});
		}


	/*
	########     ###     ######   #### ##    ##    ###    ######## ####  #######  ##    ##
	##     ##   ## ##   ##    ##   ##  ###   ##   ## ##      ##     ##  ##     ## ###   ##
	##     ##  ##   ##  ##         ##  ####  ##  ##   ##     ##     ##  ##     ## ####  ##
	########  ##     ## ##   ####  ##  ## ## ## ##     ##    ##     ##  ##     ## ## ## ##
	##        ######### ##    ##   ##  ##  #### #########    ##     ##  ##     ## ##  ####
	##        ##     ## ##    ##   ##  ##   ### ##     ##    ##     ##  ##     ## ##   ###
	##        ##     ##  ######   #### ##    ## ##     ##    ##    ####  #######  ##    ##
	*/
		watchPaginationControls()
		{
			// this.paginationControls.forEach(paginationButton => {
			// 	paginationButton.addEventListener('click', (e) => {
			// 		e.preventDefault();
			// 		this.changeToPage(paginationButton.getAttribute('href'));
			// 	});
			// });
			this.navButtonPrev.forEach(btn =>
			{
				btn.addEventListener('click', () =>
				{
					this.changeToPage(btn.dataset.target);
				});
			});
			this.navButtonNext.forEach(btn =>
			{
				btn.addEventListener('click', () =>
				{
					// Which payment method did they choose?
					if (this.form.dataset.paymentMethod)
					{
						// Both card and bank (ACH via Stripe Financial Connections)
						// need the Stripe.js instance initialized -- IJM Netherlands
						// (Findock) never uses Stripe.js at all (allFormSettings has
						// no stripe_key for ijmNl), so calling this would throw
						// trying to construct Stripe(undefined, ...).
						if (allFormSettings.site_handle !== 'ijmNl')
						{
							this.initStripe();
						}
						this.updateTransactionFees();
					}
					// Make sure the current page is valid before switching
					if ( this.checkPageValidity() )
					{
						const target = btn.dataset.target;
						if (target.includes('form-page--2'))
						{
							this.sfmcLeadWrite(1);
							this.trackFunnelStep('begin_checkout');
						}
						if (target.includes('form-page--3'))
						{
							this.sfmcLeadWrite(2);
							this.trackFunnelStep('add_payment_info');
						}
						this.changeToPage(target);

						// "Continue to Payment" doubles as the check-customer
						// trigger (formerly a second, independent listener in
						// watchForDonorIdCheck() on this same button/click).
						// That second listener ran its own checkPageValidity()
						// call too -- but by the time IT ran (listeners fire in
						// registration order, and this one was registered
						// first), changeToPage() above had already made page 3
						// the active page, so checkPageValidity() checked page
						// 3's still-untouched card field instead of the page
						// actually being left. That's what showed a card error
						// the instant page 3 became visible, before the donor
						// had done anything there. Firing it from inside this
						// single, already-gated handler instead removes the
						// second call (and the page-identity ambiguity)
						// entirely.
						if ( btn.classList.contains('jsCheckCustomer') )
						{
							if(showDebug) console.log('handleStripeClientSecret()');
							this.handleStripeClientSecret();
						}
					}
					else
					{
						if(showDebug) console.warn("Not changing to the next page since this page has form inputs that aren't valid.");
					}
				});
			});
		}

		sfmcLeadWrite(stage)
		{
			// SFMC (Salesforce Marketing Cloud) lead tracking is a US/CA-only
			// marketing integration -- ijmNl uses Salesforce NPSP via Findock
			// instead and has no SFMC credentials configured at all, so this
			// call would always 500 there (SfmcClient's $subdomain etc. are
			// read straight from env vars with no ijmNl equivalent). Rather
			// than gate every call site individually, bail out once here.
			if (allFormSettings.site_handle === 'ijmNl') return;

			const form = this.form;
			const payload = { lead_id: this.leadId, stage };

			for (const [key, val] of Object.entries(this.sfmcTracking)) {
				if (val !== null) payload[key] = val;
			}

			payload.amount                 = this.totalAmountField?.value;
			payload.recurrence             = form.dataset.recurrence;
			payload.cover_transaction_fees = this.transactionFeesCheckbox?.checked ? '1' : '0';
			payload.fees_amount            = this.feesAmounts[0]?.textContent ?? '0';
			payload.payment_method         = form.dataset.paymentMethod;

			if (stage >= 2) {
				['billing_first_name', 'billing_last_name', 'email', 'phone',
				 'billing_country', 'billing_address', 'billing_city', 'billing_state', 'billing_zip']
				.forEach(name => {
					const el = form.querySelector(`[name="${name}"]`);
					if (el?.value) payload[name] = el.value;
				});
			}

			if (stage === 3) {
				payload.donation = true;
			}

			fetch('/actions/sfmc/sfmc-lead/write', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(payload),
			}).then((res) => {
				// fetch() only rejects on a genuine network failure, not on a
				// non-2xx status -- check res.ok too, so a misconfigured/down
				// SFMC connection (e.g. a 500 from missing credentials) is at
				// least visible in debug mode instead of silently vanishing.
				if (!res.ok && showDebug) {
					console.error(`sfmcLeadWrite(${stage}): HTTP ${res.status}`);
				}
			}).catch((error) => {
				if (showDebug) console.error(`sfmcLeadWrite(${stage}):`, error);
			});
		}

		changeToPage(pageId)
		{
			this.formPages.forEach(page =>
			{
				page.classList.replace('flex', 'hidden');
			});
			this.dfc.querySelector(pageId).classList.replace('hidden', 'flex');

			// Reset scroll position on advance. In the sidebar drawer
			// (formLocation=sidebar), the scrolling element is the drawer's
			// own overflow-auto content div, not the window -- most
			// noticeable on mobile, where that drawer takes up most/all of
			// the viewport, so a donor who scrolled down through a page's
			// fields would otherwise land on the next page already scrolled
			// past the fold, with no visual cue to scroll back up. Walk up
			// to the nearest actually-scrollable ancestor instead of
			// hardcoding which container that is, so this also does the
			// right thing for the "main" (full-page, not-in-a-drawer)
			// formLocation, where the window itself is what's scrolled.
			this.scrollToPageTop();
		}

		scrollToPageTop()
		{
			let el = this.dfc.parentElement;
			while (el && el !== document.body)
			{
				let style = getComputedStyle(el);
				if ( /(auto|scroll)/.test(style.overflowY) && el.scrollHeight > el.clientHeight )
				{
					el.scrollTo({ top: 0, behavior: 'smooth' });
					return;
				}
				el = el.parentElement;
			}
			// No scrollable ancestor found (formLocation=main) -- the page
			// itself is what's scrolled.
			(document.scrollingElement || document.documentElement).scrollTo({ top: 0, behavior: 'smooth' });
		}
	/*
	| ##     ##    ###    ##       #### ########     ###    ######## ####  #######  ##    ##
	| ##     ##   ## ##   ##        ##  ##     ##   ## ##      ##     ##  ##     ## ###   ##
	| ##     ##  ##   ##  ##        ##  ##     ##  ##   ##     ##     ##  ##     ## ####  ##
	| ##     ## ##     ## ##        ##  ##     ## ##     ##    ##     ##  ##     ## ## ## ##
	|  ##   ##  ######### ##        ##  ##     ## #########    ##     ##  ##     ## ##  ####
	|   ## ##   ##     ## ##        ##  ##     ## ##     ##    ##     ##  ##     ## ##   ###
	|    ###    ##     ## ######## #### ########  ##     ##    ##    ####  #######  ##    ##

		Validation
		----------------------------------------------------------------------
	*/
		watchFields()
		{
			let allFields = this.form.querySelectorAll('input, select');
			allFields.forEach(field =>
			{
				field.addEventListener('blur', () =>
				{
					this.checkFieldValidity(field);
				});
			});
		}

		checkFieldValidity(field)
		{
			let isValidField = field.checkValidity() || this.isValidIgnoringStepMismatch(field);
			if ( isValidField )
			{
				if (field.classList.contains('-error'))
				{
					this.removeFieldError(field);
				}
				return true;
			}
			else
			// Invalid field
			{
				// If there's no error shown yet
				if ( ! field.classList.contains('-error') )
				{
					this.addFieldError(field);
				}
				else
				{
					// Already flagged, but the reason can have changed since
					// (empty -> filled in but malformed, too low -> too high);
					// showErrorMessage() upserts, so this just refreshes the
					// text instead of leaving the first message showing.
					this.showErrorMessage(field);
				}
				return false;
			}
		}

		// Only the amount field currently sets step="1" for its native
		// up/down-stepping behavior (see donationWidget.twig), which means
		// checkValidity() flags any typed value with cents as a
		// stepMismatch even though that's a perfectly valid amount --
		// stepMismatch is only meant to govern how far stepUp()/stepDown()
		// move, not whether a hand-typed value is acceptable. This treats
		// the field as valid when stepMismatch is the *only* failing
		// constraint; every other constraint (required, min, etc.) still
		// applies normally. (More than 2 decimal places can't reach this
		// field at all -- watchAmountField()'s 'input' listener truncates
		// it as the donor types.)
		isValidIgnoringStepMismatch(field)
		{
			let v = field.validity;
			return v.stepMismatch
				&& !v.valueMissing && !v.typeMismatch && !v.patternMismatch
				&& !v.tooLong && !v.tooShort && !v.rangeUnderflow && !v.rangeOverflow
				&& !v.badInput && !v.customError;
		}

		addFieldError(field)
		{
			// if(showDebug) console.info('The "#' + field.id + '" field is invalid.');
			field.classList.add('-error');
			this.showErrorMessage(field);
			// Store the handler on the field itself so removeFieldError() can
			// pass the same reference to removeEventListener() -- a fresh
			// arrow function there would never match this one, silently
			// leaving the listener attached forever.
			if (!field._keyupValidityHandler) {
				field._keyupValidityHandler = () => this.checkFieldValidity(field);
				field.addEventListener('keyup', field._keyupValidityHandler);
			}
		}

		removeFieldError(field)
		{
			field.classList.remove('-error');
			this.hideErrorMessage(field);
			if (field._keyupValidityHandler) {
				field.removeEventListener('keyup', field._keyupValidityHandler);
				delete field._keyupValidityHandler;
			}
		}

		showErrorMessage(field, message)
		{
			// figure out text
			let errorText = allFormSettings.site_handle === 'ijmNl' ? "Dit veld bevat een fout." : "This field has errors.";
			if (message)
			{
				errorText = message;
			}
			else if (this.errorMessages[field.id])
			{
				if (field.validity.rangeUnderflow == true)
				{
					let msg = this.errorMessages[field.id].rangeUnderflow;
					errorText = msg.pre + field.min + msg.post;
				}
				else if (field.validity.rangeOverflow == true && this.errorMessages[field.id].rangeOverflow)
				{
					let msg = this.errorMessages[field.id].rangeOverflow;
					// Formatted with commas (e.g. "250,000") -- unlike the
					// minimum above, this number is large enough that an
					// unformatted field.max would be hard to read at a
					// glance.
					errorText = msg.pre + Number(field.max).toLocaleString() + msg.post;
				}
				else if (field.validity.customError == true)
				{
					// setCustomValidity() (e.g. updateTransactionFees()'s
					// fee-inclusive-total check) already builds the full,
					// specific message -- field.validationMessage is just
					// that same string handed back by the browser.
					errorText = field.validationMessage;
				}
				else if ((field.validity.patternMismatch || field.validity.typeMismatch) && this.errorMessages[field.id].invalidFormat)
				{
					// Filled in, just not shaped like a valid email --
					// distinct from field.validity.valueMissing (empty),
					// which falls through to .generic below.
					errorText = this.errorMessages[field.id].invalidFormat;
				}
				else if (this.errorMessages[field.id].generic)
				{
					errorText = this.errorMessages[field.id].generic;
				}
				else
				{
					errorText = this.errorMessages[field.id];
				}
				// errorText = this.errorMessages[field.id];
			}
			else if (field.required)
			{
				errorText = allFormSettings.site_handle === 'ijmNl' ? "Dit veld is verplicht." : "This field is required.";
			}

			// Upsert rather than blind-append: callers that aren't gated by
			// checkFieldValidity()'s own "-error" class check (e.g. the
			// Stripe card Element's "change" event, which can fire
			// repeatedly while still invalid, or checkPageValidity() being
			// run more than once against the same unresolved field) would
			// otherwise stack a fresh duplicate label under the field on
			// every call instead of just updating the one already showing.
			let error = field.id ? field.parentNode.querySelector('label[for=' + field.id + '].errorMessage') : null;
			if ( ! error )
			{
				error = document.createElement('label');
				error.setAttribute('for', field.id);
				error.classList.add('errorMessage', 'text-red-500', 'text-xs', 'font-medium','cursor-pointer');
				error.role = 'alert';
				field.parentNode.appendChild(error);
			}
			error.innerText = errorText;


			// display message
		}

		hideErrorMessage(field)
		{
			if ( field.id )
			{
				let errorMessage = field.parentNode.querySelector('label[for=' + field.id + '].errorMessage');
				if (errorMessage)
				{
					errorMessage.remove();
				}
			}
		}

		checkPageValidity()
		{
			// Reset error var
			let pageHasErrors = false;

			// Store active page
			let activePage = this.dfc.querySelector('.jsFormPage.flex');

			// Find all required fields on active page
			let requiredFields = activePage.querySelectorAll('[required]');

			// Check each field for validity
			requiredFields.forEach(requiredField =>
			{
				// this.checkFieldValidity(requiredField);
				if ( ! this.checkFieldValidity(requiredField))
				{
					pageHasErrors = true;
				}
			});

			// The Stripe card Element has no [required] attribute the scan
			// above can see (it's an iframe, not a native input), so an
			// empty/incomplete card number previously sailed straight past
			// this check and on into stripe.confirmCardPayment() -- which
			// correctly rejected it, but only after the processing overlay
			// had already opened, surfacing as a redundant "Oops" on top of
			// Stripe's own inline field error. Only relevant when the card
			// element is actually part of the page being checked (page 3,
			// card payment method) and Stripe has mounted it at all.
			if ( this.card && activePage.contains(this.cardElement) && this.form.dataset.paymentMethod !== 'bank' )
			{
				if ( ! this.cardComplete )
				{
					// showErrorMessage() upserts (see its own comment) rather
					// than blind-appending, so calling this repeatedly (e.g.
					// clicking "Complete Your Gift" twice with the card still
					// empty) updates the existing label instead of stacking
					// duplicates under the card field.
					this.showErrorMessage(this.cardElement, 'Your card number is incomplete.');
					pageHasErrors = true;
				}
			}

			if (pageHasErrors) {
				return false;
			} else {
				return true;
			}
		}

	/**
	##    ##    ###    ##     ## ########     ######  ##        #######  ##    ## ########
	###   ##   ## ##   ###   ### ##          ##    ## ##       ##     ## ###   ## ##
	####  ##  ##   ##  #### #### ##          ##       ##       ##     ## ####  ## ##
	## ## ## ##     ## ## ### ## ######      ##       ##       ##     ## ## ## ## ######
	##  #### ######### ##     ## ##          ##       ##       ##     ## ##  #### ##
	##   ### ##     ## ##     ## ##          ##    ## ##       ##     ## ##   ### ##
	##    ## ##     ## ##     ## ########     ######  ########  #######  ##    ## ########
	/**
	 * Name Clone
	 * ------------------------------------------------------------------------
	 * Copies First Name & Last Name from page 2 to Page 3
	 */
		watchNameFields()
		{
			//  Billing Name
			let bfname = this.dfc.querySelector('[name="billing_first_name"]');
			let blname = this.dfc.querySelector('[name="billing_last_name"]');

			//  Credit Card Name
			let cfname = this.dfc.querySelector('[name="cc_first_name"]');
			let clname = this.dfc.querySelector('[name="cc_last_name"]');

			// IJM Netherlands' page 3 has no cc_first_name/cc_last_name at
			// all -- Findock's hosted checkout collects card details
			// off-site, so there's no local card billing_details to keep
			// in sync.
			if (cfname) {
				bfname.addEventListener('change', () => {
					cfname.value = bfname.value;
				});
			}

			if (clname) {
				blname.addEventListener('change', () => {
					clname.value = blname.value;
				});
			}
		}

	/*
	##     ##    ###    #### ##        ######  ##     ## ########  ######  ##    ##
	###   ###   ## ##    ##  ##       ##    ## ##     ## ##       ##    ## ##   ##
	#### ####  ##   ##   ##  ##       ##       ##     ## ##       ##       ##  ##
	## ### ## ##     ##  ##  ##       ##       ######### ######   ##       #####
	##     ## #########  ##  ##       ##       ##     ## ##       ##       ##  ##
	##     ## ##     ##  ##  ##       ##    ## ##     ## ##       ##    ## ##   ##
	##     ## ##     ## #### ########  ######  ##     ## ########  ######  ##    ##
	*/
		watchMailcheckFields()
		{
			let mailcheckFields = this.dfc.querySelectorAll('.jsMailcheck');
			mailcheckFields.forEach(field => {
				let suggestionBox = field.parentNode.querySelector('.jsSuggestedEmailBox');
				let suggestedAddress = suggestionBox.querySelector('.jsSuggestedEmailAddress');
				field.addEventListener('blur', () => {
					mailcheck.run(
					{
						email: field.value,
						suggested: function(suggestion)
						{
							field.classList.add('text-red-500');
							suggestedAddress.value = suggestion.full;
							suggestedAddress.innerHTML = `${suggestion.address}@<strong>${suggestion.domain}</strong>`;
							suggestionBox.classList.replace('hidden', 'block');
						},
						empty: function()
						{
							field.classList.remove('text-red-500');
							suggestionBox.classList.replace('block', 'hidden');
						}
					});
				});
			});
		}

		watchSuggestedEmails()
		{
			let emailSuggestions = this.dfc.querySelectorAll('.jsSuggestedEmailAddress');
			emailSuggestions.forEach(emailSuggestion => {
				let suggestionBox = emailSuggestion.closest('.jsSuggestedEmailBox');
				let emailField = suggestionBox.parentNode.querySelector('.jsMailcheck');
				emailSuggestion.addEventListener('click', () =>
				{
					suggestionBox.classList.replace('block', 'hidden');
					emailField.value = emailSuggestion.value;
					emailField.classList.remove('text-red-500');
					emailSuggestion.closest('form').checkValidity();
				});
			});
		}

		watchSuggestedEmailCloseButton()
		{
			let suggestedEmailCloseBtns = this.dfc.querySelectorAll('.jsSuggestedEmailClose');
			suggestedEmailCloseBtns.forEach(btn => {
				let suggestionBox = btn.closest('.jsSuggestedEmailBox');
				btn.addEventListener('click', () => {
					suggestionBox.classList.replace('block', 'hidden');
					suggestionBox.parentNode.querySelector('.jsMailcheck').classList.remove('text-red-500');
				});
			});
		}
	/**
	|  ######   #######  ##     ## ##    ## ######## ########  ##    ##          ##
	| ##    ## ##     ## ##     ## ###   ##    ##    ##     ##  ##  ##          ##
	| ##       ##     ## ##     ## ####  ##    ##    ##     ##   ####          ##
	| ##       ##     ## ##     ## ## ## ##    ##    ########     ##          ##
	| ##       ##     ## ##     ## ##  ####    ##    ##   ##      ##         ##
	| ##    ## ##     ## ##     ## ##   ###    ##    ##    ##     ##        ##
	|  ######   #######   #######  ##    ##    ##    ##     ##    ##       ##
	|
	|  ######  ########    ###    ######## ########
	| ##    ##    ##      ## ##      ##    ##
	| ##          ##     ##   ##     ##    ##
	|  ######     ##    ##     ##    ##    ######
	|       ##    ##    #########    ##    ##
	| ##    ##    ##    ##     ##    ##    ##
	|  ######     ##    ##     ##    ##    ########
	|
	| ######## #### ######## ##       ########   ######
	| ##        ##  ##       ##       ##     ## ##    ##
	| ##        ##  ##       ##       ##     ## ##
	| ######    ##  ######   ##       ##     ##  ######
	| ##        ##  ##       ##       ##     ##       ##
	| ##        ##  ##       ##       ##     ## ##    ##
	| ##       #### ######## ######## ########   ######

	* Country / State fields
	* ------------------------------------------------------------------------
	*/

		toggleStateField()
		{
			// let stateField = this.dfc.querySelector('#state');
			let stateFieldset = this.dfc.querySelector('.jsStateField');
			let zipLabel = this.dfc.querySelector('.jsZipLabel');

			// IJM Netherlands has no State field at all (postcode +
			// huisnummer instead of state/zip) -- nothing to toggle.
			if (!stateFieldset || !zipLabel) return;

			switch (this.country.value)
			{
				// USA
				case 'US':
					stateFieldset.classList.replace('hidden', 'flex');
					this.state.disabled = false;
					zipLabel.innerText = 'Zip Code';
					break;

				// Rest of world
				default:
					stateFieldset.classList.replace('flex', 'hidden');
					this.state.disabled = true;
					zipLabel.innerText = 'Postal Code';
					break;
			}
		}

		watchCountry()
		{
			this.country.addEventListener('change', () =>
			{
				this.toggleStateField();
			});
		}

		// Address Lookup (ijmNl only) -- postcode + huisnummer -> street/city,
		// via apicheck.nl, matching the donation form on the old
		// ijmnl-www-craft3 site (same service, same API key).
		watchAddressLookup()
		{
			if (allFormSettings.site_handle !== 'ijmNl') return;
			if (!this.zip || !this.huisNummer) return;

			let lookup = () => this.lookupAddress();
			this.zip.addEventListener('blur', lookup);
			this.huisNummer.addEventListener('blur', lookup);
			// Toevoeging: some house numbers only exist with an addition
			// (apicheck answers "no_exact_match" for e.g. 7331 DL 122 until
			// it's told the addition is A or B), so a donor who types the
			// addition last still needs the lookup to run. Country: re-run if
			// they pick/return to Nederland after already filling in the rest
			// (same triggers as the Freeform version of this lookup).
			if (this.toevoeging) this.toevoeging.addEventListener('blur', lookup);
			this.country.addEventListener('change', lookup);
		}

		// Keeps the Phone opt-out checkbox's visibility reactive to typing,
		// not just to recurrence/mode changes -- see
		// updatePhoneOptOutVisibility() for why it needs both.
		watchPhoneOptOut()
		{
			if (allFormSettings.site_handle !== 'ijmNl') return;
			if (!this.phoneField) return;

			this.phoneField.addEventListener('input', () => this.updatePhoneOptOutVisibility());

			this.watchPhoneInfoPopup();
		}

		// The "i" button beside the opt-out label toggles a small popup with
		// the explanation (a hover-only title attribute never shows on touch
		// screens). Closes on its X, an outside click, or Escape -- Escape is
		// swallowed while the popup is open so it doesn't also close the
		// donation drawer (<dialog>) behind it.
		watchPhoneInfoPopup()
		{
			if (!this.phoneOptOutWrapper) return;

			let button = this.phoneOptOutWrapper.querySelector('.jsPhoneInfoButton');
			let popup = this.phoneOptOutWrapper.querySelector('.jsPhoneInfoPopup');
			let closeButton = this.phoneOptOutWrapper.querySelector('.jsPhoneInfoClose');
			if (!button || !popup) return;

			let setOpen = (open, returnFocus = false) =>
			{
				popup.classList.toggle('hidden', !open);
				button.setAttribute('aria-expanded', open ? 'true' : 'false');
				if (!open && returnFocus) button.focus();
			};

			button.addEventListener('click', (e) =>
			{
				e.preventDefault();
				setOpen(popup.classList.contains('hidden'));
			});
			if (closeButton) closeButton.addEventListener('click', () => setOpen(false, true));

			document.addEventListener('click', (e) =>
			{
				if (popup.classList.contains('hidden')) return;
				if (popup.contains(e.target) || button.contains(e.target)) return;
				setOpen(false);
			});
			document.addEventListener('keydown', (e) =>
			{
				if (e.key !== 'Escape' || popup.classList.contains('hidden')) return;
				e.preventDefault();
				e.stopPropagation();
				setOpen(false, true);
			}, true);

			// Wrapper itself being hidden (phone emptied/hidden) must not leave
			// a stale "expanded" state behind for the next time it appears.
			this.phoneInfoPopupClose = () => setOpen(false);
		}

		// Looks up the street and city for the currently-entered postcode +
		// huisnummer (+ toevoeging, when filled in) via apicheck.nl and fills
		// them into the Straatnaam/Plaats fields. Only fires for NL addresses
		// -- this lookup endpoint is NL-postcode-specific, so anything else
		// would just be a meaningless/failed call.
		async lookupAddress()
		{
			if (!this.zip.value || !this.huisNummer.value || this.country.value !== 'NL') return;

			// Matches ijmnl-www-craft3's apicheck.js request shape exactly
			// (including the raw, non-URLSearchParams-encoded "fields"
			// param) since that's the proven-working request the API
			// accepts. numberAddition is only sent when there is one: sending
			// an addition that doesn't exist for the address (e.g. 3523 JS 31
			// "A") makes apicheck answer no_exact_match even though the plain
			// number would have matched.
			let params = {
				postalcode: this.zip.value,
				number: this.huisNummer.value,
			};
			let addition = this.toevoeging ? this.toevoeging.value.trim() : '';
			if (addition) params.numberAddition = addition;
			let paramsString = new URLSearchParams(params);
			paramsString += '&fields=["city","street"]';
			let url = `https://api.apicheck.nl/lookup/v1/postalcode/nl?${paramsString}`;

			// zip, huisnummer, toevoeging and country each trigger a lookup, so
			// several can be in flight at once -- only the newest one may write
			// to the form, or a slow response for an earlier value could
			// overwrite the result for what the donor typed last.
			let requestId = this.addressLookupSeq = (this.addressLookupSeq || 0) + 1;

			try
			{
				let response = await fetch(url, {
					headers: {
						'X-API-Key': allFormSettings.apicheck_api_key,
					},
				});
				let results = await response.json();

				if (requestId !== this.addressLookupSeq) return;

				if (results.error === true)
				{
					console.warn(results.description);
					return;
				}

				this.address.value = results.data.street;
				this.address.dispatchEvent(new Event('input', {bubbles: true}));

				this.city.value = results.data.city;
				this.city.dispatchEvent(new Event('input', {bubbles: true}));
			}
			catch (err)
			{
				console.warn('Address lookup failed:', err);
			}
		}


/*
|  #######  ##     ## ######## ########  ##          ###    ##    ##
| ##     ## ##     ## ##       ##     ## ##         ## ##    ##  ##
| ##     ## ##     ## ##       ##     ## ##        ##   ##    ####
| ##     ## ##     ## ######   ########  ##       ##     ##    ##
| ##     ##  ##   ##  ##       ##   ##   ##       #########    ##
| ##     ##   ## ##   ##       ##    ##  ##       ##     ##    ##
|  #######     ###    ######## ##     ## ######## ##     ##    ##
*/

		// Change the heading in the overlay
		setOverlayHeading(text = '')
		{
			if (text)
			{
				this.overlayHeading.textContent = text;
				this.overlayHeading.classList.add('-shown');
			}
			else
			{
				this.overlayHeading.textContent = '';
				this.overlayHeading.classList.remove('-shown');
			}
		}

		// Change the test in the overlay
		setOverlayText(text = '')
		{
			if (text)
			{
				this.overlayText.textContent = text;
				this.overlayText.classList.add('-shown');
			}
			else
			{
				this.overlayText.textContent = '';
				this.overlayText.classList.remove('-shown');
			}
		}

		// Set progress bar to a specific step
		setProgressBar(value)
		{
			this.overlayProgressBar.value = value;
		}

		// Advance progress bar by one step
		incrementProgressBar(step = 1)
		{
			let max = this.overlayProgressBar.max;
			// If there's room to progress
			if (this.overlayProgressBar.value < max)
			{
				if (this.overlayProgressBar.value + step > max)
				{
					this.overlayProgressBar.value = max;
					return true;
				}
				else
				{
					this.overlayProgressBar.value += step;
					return this.overlayProgressBar.value;
				}
			}
			else
			{
				return false;
			}
		}

		// Change text of progress bar's label
		setProgressLabel(text)
		{
			this.overlayProgressLabel.textContent = text;
		}

		// Show overlay's close button
		showOverlayClose()
		{
			this.overlayClose.classList.add('-shown');
			this.watchOverlayClose()
		}

		// Hide overlay's close button
		hideOverlayClose()
		{
			this.overlayClose.classList.remove('-shown');
		}

		// Show overlay's retry button, wiring it to call retryFn on click.
		// Uses .onclick (not addEventListener) so re-showing it for a
		// different retryable failure replaces the previous handler instead
		// of stacking another listener on top of it.
		showOverlayRetry(retryFn)
		{
			this.overlayRetry.onclick = () =>
			{
				this.hideOverlayRetry();
				this.hideOverlayClose();
				retryFn();
			};
			this.overlayRetry.classList.add('-shown');
		}

		// Hide overlay's retry button
		hideOverlayRetry()
		{
			this.overlayRetry.classList.remove('-shown');
			this.overlayRetry.onclick = null;
		}

		// Show entire overlay
		showOverlay()
		{
			this.overlay.classList.add('-shown');
		}

		// Hide entire overlay
		hideOverlay()
		{
			this.overlay.classList.remove('-shown');
		}

		// Show/Hide "processing" spinner in overlay
		overlayProcessing(mode = true)
		{
			if (mode)
			{
				this.overlay.classList.add('-isProcessing');
			}
			else
			{
				this.overlay.classList.remove('-isProcessing');
			}
		}

		// Overlay close
		watchOverlayClose()
		{
			this.overlayClose.addEventListener('click', () =>
			{
				this.hideOverlay();
				this.hideOverlayClose();
				this.hideOverlayRetry();
				this.setOverlayHeading(); // blank
				this.setOverlayText(); // blank
			});
		}

	/*
	########     ###    ##    ## ##    ##    ###     ######   ######   #######  ##     ## ##    ## ########
	##     ##   ## ##   ###   ## ##   ##    ## ##   ##    ## ##    ## ##     ## ##     ## ###   ##    ##
	##     ##  ##   ##  ####  ## ##  ##    ##   ##  ##       ##       ##     ## ##     ## ####  ##    ##
	########  ##     ## ## ## ## #####    ##     ## ##       ##       ##     ## ##     ## ## ## ##    ##
	##     ## ######### ##  #### ##  ##   ######### ##       ##       ##     ## ##     ## ##  ####    ##
	##     ## ##     ## ##   ### ##   ##  ##     ## ##    ## ##    ## ##     ## ##     ## ##   ###    ##
	########  ##     ## ##    ## ##    ## ##     ##  ######   ######   #######   #######  ##    ##    ##
		Bank Account (ACH via Stripe Financial Connections)
		----------------------------------------------------------------------
	*/

		// Verify the donor's bank account via Stripe Financial Connections and
		// confirm the ACH PaymentIntent/Subscription-invoice PaymentIntent that
		// was already created by handleStripeClientSecret().
		collectBankAccount()
		{
			// The full-screen overlay below takes over as the loading
			// indicator from here (the Financial Connections popup is
			// about to open on top of it).
			this.setBankButtonLoading(false);

			this.setOverlayHeading('Thank You!');
			this.setOverlayText('Please wait while we process your donation.');
			this.setProgressBar(1);
			this.setProgressLabel("Processing...");

			this.showOverlay();
			this.overlayProcessing(true);

			let first_name = !!this.dfc.querySelector('input[name="billing_first_name"]') ? this.dfc.querySelector('input[name="billing_first_name"]').value : "";
			let last_name = !!this.dfc.querySelector('input[name="billing_last_name"]') ? this.dfc.querySelector('input[name="billing_last_name"]').value : "";
			let bank_name = (first_name + " " + last_name).trim();
			let bank_email = !!this.dfc.querySelector('input[name="email"]') ? this.dfc.querySelector('input[name="email"]').value : "";

			let frequency = !!this.form.frequency ? this.form.frequency.value : "";
			let clientSecret = null;

			switch (frequency) {
				case 'monthly':
				case 'annually':
					clientSecret = !!this.form.querySelector('[name="subscription_client_secret"]') ? this.form.querySelector('[name="subscription_client_secret"]').value : null;
					break;

				default:
					clientSecret = !!this.form.querySelector('[name="client_secret"]') ? this.form.querySelector('[name="client_secret"]').value : null;
			}

			if (clientSecret == null)
			{
				this.handleError(getDefaultErrMsg() + " (Error-ACH0)");
				return;
			}

			stripe.collectBankAccountForPayment({
				clientSecret: clientSecret,
				params: {
					payment_method_type: 'us_bank_account',
					payment_method_data: {
						billing_details: {
							name: bank_name,
							email: bank_email
						}
					}
				},
				expand: ['payment_method']
			}).then((result) => {

				if (result.error)
				{
					let errMsg = !!result.error.message ? result.error.message + ' (Error-ACH1)' : getDefaultErrMsg();
					if(showDebug) console.log(errMsg);
					this.handleError(errMsg);
					return;
				}

				// Per Stripe's own documented example for
				// collectBankAccountForPayment(), a paymentIntent.status of
				// 'requires_payment_method' at this point (with no error)
				// means the donor closed the Financial Connections popup
				// without completing it (or completed it but instant
				// verification failed) -- no payment method ever got
				// attached. Calling confirmUsBankAccountPayment() in that
				// state fails with Stripe's own internal-API wording ("A
				// payment method of type us_bank_account was expected to
				// be present... Try again providing either the
				// payment_method or payment_method_data parameters"),
				// which reads like a bug report, not something a donor
				// can act on. Catch it here instead with an offer to
				// retry, before that confusing call is ever made.
				if (result.paymentIntent.status === 'requires_payment_method')
				{
					this.handleBankConnectionIncomplete();
					return;
				}

				return stripe.confirmUsBankAccountPayment(clientSecret);

			}).then((result) => {

				// A prior step in the chain already handled the error
				// and returned without a result.
				if (!result) return;

				if (result.error)
				{
					let errMsg = !!result.error.message ? result.error.message + ' (Error-ACH2)' : getDefaultErrMsg();
					if(showDebug) console.log(errMsg);
					this.handleError(errMsg);
					return;
				}

				// ACH PaymentIntents settle asynchronously (3-5 business days),
				// so "processing" is an acceptable status here, not just "succeeded".
				let paymentIntentStatus = !!result.paymentIntent.status ? result.paymentIntent.status : "failed";
				if (paymentIntentStatus === 'processing' || paymentIntentStatus === 'succeeded')
				{
					if(showDebug) console.log('Payment Intent Object:');
					if(showDebug) console.log(result.paymentIntent);

					let paymentIntent = result.paymentIntent;
					this.form.payment_intent_id.value = paymentIntent.id;

					// Re-enter the submit handler (captcha gating + finalize)
					// the same way the card flow's own submit button does.
					this.form.dispatchEvent(new Event("submit"));
				}
				else
				{
					this.handleError(getDefaultErrMsg() + ' (Error-ACH3)');
				}

			}).catch((error) => {
				if(showDebug) console.log('Error collecting bank account:', error);
				this.handleError(getDefaultErrMsg() + ' (Error-ACH4)');
			});
		}

		watchBankClick()
		{
			// IJM Netherlands has no bank (ACH) button -- Direct Debit is
			// collected directly via IBAN fields, not Stripe Financial
			// Connections.
			if (!this.bankBtn) return;

			// AJAX close
			this.bankBtn.addEventListener('click', (e) =>
			{
				e.preventDefault();

				// Check if the form validation
				if ( this.checkPageValidity() )
				{
					this.setBankButtonLoading(true);
					this.handleStripeClientSecret(() => this.collectBankAccount());
				}
			});
		}

		// Toggles the bank button between its normal state and a disabled,
		// spinner + "Connecting..." state. Financial Connections can't open
		// its popup until a reCAPTCHA round-trip and a client-secret.php
		// server round-trip both finish, and nothing else on screen changes
		// while that's happening -- without this, a donor watching a static
		// button after clicking it has no way to tell their click landed.
		// Cleared by collectBankAccount() once the popup is about to open
		// (the full-screen overlay takes over as the loading indicator from
		// there), or by showRecaptchaFailure()/handleError() if anything in
		// between fails -- both are harmless no-ops here if the bank button
		// was never the thing that triggered them.
		setBankButtonLoading(isLoading)
		{
			if (!this.bankBtn) return;

			this.bankBtn.disabled = isLoading;

			let textEl = this.bankBtn.querySelector('.jsBankButtonText');
			if (textEl)
			{
				if (isLoading)
				{
					if (!textEl.dataset.originalText) textEl.dataset.originalText = textEl.textContent;
					textEl.textContent = 'Connecting...';
				}
				else if (textEl.dataset.originalText)
				{
					textEl.textContent = textEl.dataset.originalText;
				}
			}

			let spinner = this.bankBtn.querySelector('.jsBankButtonSpinner');
			if (spinner) spinner.classList.toggle('hidden', !isLoading);
		}


		/**
	|  ######  ######## ########  #### ########  ########
	| ##    ##    ##    ##     ##  ##  ##     ## ##
	| ##          ##    ##     ##  ##  ##     ## ##
	|  ######     ##    ########   ##  ########  ######
	|       ##    ##    ##   ##    ##  ##        ##
	| ##    ##    ##    ##    ##   ##  ##        ##
	|  ######     ##    ##     ## #### ##        ########
		* HANDLE STRIPE
		*/

		initStripe()
		{
			if(showDebug) console.group('initStripe()');
			// Check if the Stripe has been initialized
			if ( stripe === null )
			{
				if(showDebug) console.log('stripe === null');

				// Load in the Stripe js lib
				include("https://js.stripe.com/v3/?.js", () => {
					stripe = Stripe(allFormSettings.stripe_key, {
						//apiVersion: '2023-10-16'
						apiVersion: '2024-06-20'
					});
					if ( !this.stripeRendered )
						this.renderStripe();
				});
			}
			// If Stripe initialized check if it has been rendered
			else
			{
				if(showDebug) console.log('stripe NOT === null');
				if ( !this.stripeRendered )
					this.renderStripe();
			}
			if(showDebug) console.groupEnd();
		}

		renderStripe()
		{

			if(showDebug) console.group('renderStripe()');
			// Create an instance of Elements.
			try {
				if(showDebug) console.log("Try to create an instance of stripe.elements().");
				const elements = stripe.elements();

				// Custom styling can be passed to options when creating an Element.
				// (Note that this demo uses a wider set of styles than the guide below.)
				var style = {
					base: {
						color: "#32325d",
						lineHeight: "18px",
						fontFamily: "\"Helvetica Neue\", Helvetica, sans-serif",
						fontSmoothing: "antialiased",
						fontSize: "16px",
						"::placeholder": {
							color: "#aab7c4"
						}
					},
					invalid: {
						color: "#fa755a",
						iconColor: "#fa755a"
					}
				};

				// Create an instance of the card Element.
				try {
					if(showDebug) console.log("Try to create a Stripe card element");
					this.card = elements.create("card", {style: style, hidePostalCode: true});

					// Add an instance of the card Element into the `card-element` <div>.
					try {
						if(showDebug) console.log(`Try to add an instance of the card Element into the #${this.ns}card-element <div>`);
						this.card.mount(`#${this.ns}card-element`);

						// Handle real-time validation errors from the card Element.
						this.card.addEventListener("change", (event) =>
						{
							// var displayError = document.getElementById(`${this.ns}card-errors`);
							this.cardComplete = event.complete;
							if (event.error)
							{
								this.showErrorMessage(this.cardElement, event.error.message)
							}
							else
							{
								this.hideErrorMessage(this.cardElement)
							}
						});

						String.prototype.replaceAll = function(search, replacement)
						{
							var target = this;
							return target.split(search).join(replacement);
						};

						// Stripe rendered
						this.stripeRendered = true;

					} catch (error) {

						if(showDebug) console.error("Error mounting Stripe card element:", error);
						this.logDonationError(`Error mounting Stripe card element: ${error?.message ?? error} (Error-CSC8)`);

					}

				} catch (err) {
					console.error("Error creating Stripe card element:", err);
					this.logDonationError(`Error creating Stripe card element: ${err?.message ?? err} (Error-CSC7)`);
				}

			} catch (err) {
				console.error("Stripe elements initialization failed:", err);
				this.logDonationError(`Stripe elements initialization failed: ${err?.message ?? err} (Error-CSC6)`);
			}

			if(showDebug) console.groupEnd();
		} // renderStripe()


		// Retrieve the Stripe Client Secret
		handleStripeClientSecret(onSuccess)
		{

			if(showDebug) console.group('handleStripeClientSecret()');

			try {

				if(showDebug) console.info('Start Client Secret');

				// This step runs as soon as the donor advances past the
				// contact-details page -- well before the main donation
				// captcha (only generated on final submit). v3 is
				// score-based/invisible, so getting a token here adds no
				// extra friction; it's what keeps this endpoint (which
				// creates real Stripe Customers/PaymentIntents) from being
				// scriptable at will.
				getRecaptchaToken('check_customer')
					.then((token) => this.sendClientSecretRequest(token, onSuccess))
					.catch((error) => {
						if (showDebug) console.error('reCAPTCHA v3 Error:', error);
						this.showRecaptchaFailure(() => {
							// This flow never shows the overlay on a normal
							// (non-error) run, so retrying should put things
							// back the way they were before the failure:
							// closed, running silently in the background.
							// (hideOverlayClose() already ran as part of the
							// retry click itself.)
							this.hideOverlay();
							this.setOverlayHeading();
							this.setOverlayText();
							this.handleStripeClientSecret(onSuccess);
						});
					});

			}
			catch(e)
			{
				if(showDebug) console.error(e);
				this.handleError("Error-CSCS4: " + e);
			}
			if(showDebug) console.groupEnd();
		}

		sendClientSecretRequest(captchaToken, onSuccess)
		{

			// // Retrieve the frequency
			// let frequency = this.dfc.querySelector('input[name="frequency"]:checked').value

			const json = {
					"donation_captcha_response":	captchaToken,
					"billing_first_name": 			!!this.dfc.querySelector('input[name="billing_first_name"]') ? this.dfc.querySelector('input[name="billing_first_name"]').value : "",
					"billing_last_name": 			!!this.dfc.querySelector('input[name="billing_last_name"]') ? this.dfc.querySelector('input[name="billing_last_name"]').value : "",
					"email": 						!!this.dfc.querySelector('input[name="email"]') ? this.dfc.querySelector('input[name="email"]').value : "",
					"email_opt_in": 				!!this.dfc.querySelector('input[name="email_opt_in"]:checked') ? 1 : 0,
					"phone": 						!!this.dfc.querySelector('input[name="phone"]') ? this.dfc.querySelector('input[name="phone"]').value : "",
					"billing_country": 				!!this.dfc.querySelector('select[name="billing_country"]') ? this.dfc.querySelector('select[name="billing_country"]').value : "",
					"billing_state": 				!!this.dfc.querySelector('select[name="billing_state"]:not([disabled])') ? this.dfc.querySelector('select[name="billing_state"]:not([disabled])').value : "",
					"billing_zip": 					!!this.dfc.querySelector('input[name="billing_zip"]') ? this.dfc.querySelector('input[name="billing_zip"]').value : "",
					"billing_city": 				!!this.dfc.querySelector('input[name="billing_city"]') ? this.dfc.querySelector('input[name="billing_city"]').value : "",
					"billing_address": 				!!this.dfc.querySelector('input[name="billing_address"]') ? this.dfc.querySelector('input[name="billing_address"]').value : "",
					"amount": 						!!this.dfc.querySelector('input[name="amount"]') ? this.dfc.querySelector('input[name="amount"]').value : "",
					"gau":							!!this.dfc.querySelector('select[name="gau"]') ? this.dfc.querySelector('select[name="gau"]').value : "",
					"frequency": 					!!this.dfc.querySelector('input[name="frequency"]') ? this.dfc.querySelector('input[name="frequency"]:checked').value : "",
					"customer_id": 					!!this.dfc.querySelector('input[name="customer_id"]') ? this.dfc.querySelector('input[name="customer_id"]').value : "",
					"customer_email":				!!this.dfc.querySelector('input[name="customer_email"]') ? this.dfc.querySelector('input[name="customer_email"]').value : "",
					"payment_method": 				this.form.dataset.paymentMethod || 'card',
					"site_handle": 					allFormSettings.site_handle,
					"campaign_id": 					!!this.dfc.querySelector('input[name="campaign_id"]') ? this.dfc.querySelector('input[name="campaign_id"]').value : "",
				    "fmv": 							!!this.dfc.querySelector('input[name="fmv"]') ? this.dfc.querySelector('input[name="fmv"]').value : "",
				    "source_channel": 				!!this.dfc.querySelector('input[name="source_channel"]') ? this.dfc.querySelector('input[name="source_channel"]').value : "",
				    "response_channel": 			!!this.dfc.querySelector('input[name="response_channel"]') ? this.dfc.querySelector('input[name="response_channel"]').value : "",
				    "version": 						!!this.dfc.querySelector('input[name="version"]') ? this.dfc.querySelector('input[name="version"]').value : "",
				    "donation_level": 				!!this.dfc.querySelector('input[name="donation_level"]') ? this.dfc.querySelector('input[name="donation_level"]').value : "",
				    "cover_transaction_fees": 		!!this.dfc.querySelector('input[name="cover_transaction_fees"]:checked') ? 1 : 0,
				    "gift_processor": 				!!this.dfc.querySelector('input[name="gift_processor"]') ? this.dfc.querySelector('input[name="gift_processor"]').value : "",
				    "redirect_to": 					!!this.dfc.querySelector('input[name="redirect_to"]') ? this.dfc.querySelector('input[name="redirect_to"]').value : "",
				    "payment_intent_id": 			!!this.dfc.querySelector('input[name="payment_intent_id"]') ? this.dfc.querySelector('input[name="payment_intent_id"]').value : "",
				    "client_secret": 				!!this.dfc.querySelector('input[name="client_secret"]') ? this.dfc.querySelector('input[name="client_secret"]').value : "",
				    "subscription_id": 				!!this.dfc.querySelector('input[name="subscription_id"]') ? this.dfc.querySelector('input[name="subscription_id"]').value : "",
				    "subscription_customer_id":		!!this.dfc.querySelector('input[name="subscription_customer_id"]') ? this.dfc.querySelector('input[name="subscription_customer_id"]').value : "",
				    "subscription_amount":			!!this.dfc.querySelector('input[name="subscription_amount"]') ? this.dfc.querySelector('input[name="subscription_amount"]').value : "",
				    "subscription_payment_intent_id": !!this.dfc.querySelector('input[name="subscription_payment_intent_id"]') ? this.dfc.querySelector('input[name="subscription_payment_intent_id"]').value : "",
				    "subscription_client_secret": 	!!this.dfc.querySelector('input[name="subscription_client_secret"]') ? this.dfc.querySelector('input[name="subscription_client_secret"]').value : ""
				};

			if(showDebug) console.info('fetch: client-secret.php');

			// fetch() has no timeout of its own -- if client-secret.php's
			// PHP process hangs (a slow/stuck Stripe API call, a DB
			// deadlock, anything that neither errors out nor completes),
			// this promise would otherwise never resolve *or* reject, so
			// none of the error handling below would ever run. The donor
			// is left staring at the "Processing..." overlay forever, with
			// no error shown and nothing logged. AbortController turns
			// that silent hang into an explicit failure after a generous
			// window (long enough to cover a normal Stripe round-trip).
			const clientSecretTimeoutMs = 20000;
			const clientSecretAbortController = new AbortController();
			const clientSecretTimeout = setTimeout(
				() => clientSecretAbortController.abort(),
				clientSecretTimeoutMs
			);

			fetch("/make-gift/client-secret.php", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(json),
				signal: clientSecretAbortController.signal
			})
			.then((res) =>
			{
				clearTimeout(clientSecretTimeout);
				if(showDebug) console.group('handleStripeClientSecret() -> fetch request');

				if (!res.ok)
				{
					let errMsg = "Error-CSCS1: For some reason the donation failed to process. Please refresh your browser and try again.";
					if(showDebug) console.error(errMsg);
					this.handleError(errMsg);
					if(showDebug) console.groupEnd();
					return;
				}

				return res.json().then((response) =>
				{
					if(showDebug) console.info('Client Secret Response');
					if(showDebug) console.debug(response);

					if (typeof response !== "undefined"
						&& response.status !== "error" )
					{
						if (response.result.hasOwnProperty('customer_id'))
						{
							let customerId = response.result.customer_id;
							this.dfc.querySelector('[name="customer_id"]').value = customerId;
						}
						if (response.result.hasOwnProperty('new_customer'))
						{
							let newCustomer = response.result.new_customer;
							this.dfc.querySelector('[name="new_customer"]').value = newCustomer;
						}
						if (response.result.hasOwnProperty('payment_intent_id'))
						{
							let paymentIntentId = response.result.payment_intent_id;
							this.dfc.querySelector('[name="payment_intent_id"]').value = paymentIntentId;
						}
						if (response.result.hasOwnProperty('client_secret') )
						{
							let clientSecret = response.result.client_secret;
							this.dfc.querySelector('[name="client_secret"]').value = clientSecret;
						}
						if (response.result.hasOwnProperty('subscription_id'))
						{
							let subscriptionId = response.result.subscription_id;
							this.dfc.querySelector('[name="subscription_id"]').value = subscriptionId;
						}
						if (response.result.hasOwnProperty('subscription_client_secret') )
						{
							let subscriptionClientSecret = response.result.subscription_client_secret;
							this.dfc.querySelector('[name="subscription_client_secret"]').value = subscriptionClientSecret;
						}

						if ( typeof onSuccess === "function" )
							onSuccess();
					}
					else
					{
						if ( typeof response === "undefined" )
						{
							let errMsg = "Error-CSCS2: For some reason the donation failed to process. Please refresh your browser and try again.";
							if(showDebug) console.error(errMsg);
							this.handleError(errMsg);
						}
						else
						{
							let errMsg = "Error-CSCS3: " + response.message;
							if(showDebug) console.error(errMsg);
							this.handleError(errMsg);
						}

					}
					if(showDebug) console.groupEnd();
				});
			})
			.catch((e) =>
			{
				clearTimeout(clientSecretTimeout);
				if(showDebug) console.error(e);

				// Give the timeout its own distinct, donor-friendly message
				// and error code -- easy to tell apart from other CSCS4
				// causes (a genuine network failure, a JSON parse error)
				// when scanning donation_errors later.
				if (e && e.name === 'AbortError')
				{
					let errMsg = "Error-CSCS5: For some reason the donation is taking longer than expected to process. Please refresh your browser and try again.";
					this.handleError(errMsg);
					return;
				}

				this.handleError("Error-CSCS4: " + e);
			});
		}

	/*
	| ########  #######  ########  ##     ##
	| ##       ##     ## ##     ## ###   ###
	| ##       ##     ## ##     ## #### ####
	| ######   ##     ## ########  ## ### ##
	| ##       ##     ## ##   ##   ##     ##
	| ##       ##     ## ##    ##  ##     ##
	| ##        #######  ##     ## ##     ##
	|
	|  ######  ##     ## ########  ##     ## #### ########
	| ##    ## ##     ## ##     ## ###   ###  ##     ##
	| ##       ##     ## ##     ## #### ####  ##     ##
	|  ######  ##     ## ########  ## ### ##  ##     ##
	|       ## ##     ## ##     ## ##     ##  ##     ##
	| ##    ## ##     ## ##     ## ##     ##  ##     ##
	|  ######   #######  ########  ##     ## ####    ##
	FORM SUBMIT
	*/

		// Shared finalize step for both card and bank (ACH) donations: the
		// PaymentIntent/Subscription has already been confirmed by this point,
		// so just POST the form (with payment_intent_id set) to donate.php.
		submitDonationForm()
		{
			const formData = new FormData(this.form);

			if(showDebug) {
				console.log('Form Values:');
				console.table( [...formData.entries()].map(([key, value]) => ({ key, value })) );
			}

			fetch("/make-gift/donate.php", {
				method: "POST",
				body: formData
			})
			.then((res) => res.text().then((text) => ({ ok: res.ok, text })))
			.then(({ ok, text }) =>
			{
				// HTTP Request Failed
				if (!ok)
				{
					this.handleError(getDefaultErrMsg() + " (Error-CSC3)");
					return;
				}

				// Reset the Stripe client secrets and card
				if ( this.dfc.querySelector('[name="client_secret"]') )
				{
					this.dfc.querySelector('[name="client_secret"]').value = "";
				}
				if ( this.dfc.querySelector('[name="subscription_client_secret"]') )
				{
					this.dfc.querySelector('[name="subscription_client_secret"]').value = "";
				}
				if ( this.card )
				{
					this.card.clear();
				}

				// Parse JSON
				if(showDebug) console.log('AJAX Response:');
				if(showDebug) console.log(text);
				if ( isValidJSON(text) )
				{
					let response = JSON.parse(text);
					// Handle the donation response
					this.handleAppDonateResponse(this, response);
				}
				else
				{
					let errMsg = text + " (Error-CSC2)";
					if(showDebug) console.log(errMsg);
					this.handleError(errMsg);
				}
			})
			.catch((e) =>
			{
				if(showDebug) console.error(e);
				this.handleError(getDefaultErrMsg() + " (Error-CSC3)");
			});
		}

		// IJM Netherlands (Findock) submit -- near-copy of submitDonationForm(),
		// kept as its own method rather than branching inside it, since the
		// Findock and Stripe paths shouldn't share logic that a future
		// Stripe-specific change could accidentally affect (see
		// handleAppDonateResponseNl()'s docblock for why the response
		// handling in particular needs to be separate).
		submitDonationFormNl()
		{
			const formData = new FormData(this.form);

			if(showDebug) {
				console.log('Form Values (NL):');
				console.table( [...formData.entries()].map(([key, value]) => ({ key, value })) );
			}

			fetch("/make-gift/donate.php", {
				method: "POST",
				body: formData
			})
			.then((res) => res.text().then((text) => ({ ok: res.ok, text })))
			.then(({ ok, text }) =>
			{
				// HTTP Request Failed
				if (!ok)
				{
					this.handleError(getDefaultErrMsg() + " (Error-NL0)");
					return;
				}

				if(showDebug) console.log('AJAX Response (NL):');
				if(showDebug) console.log(text);

				if ( isValidJSON(text) )
				{
					let response = JSON.parse(text);
					this.handleAppDonateResponseNl(this, response);
				}
				else
				{
					let errMsg = text + " (Error-NL1)";
					if(showDebug) console.log(errMsg);
					this.handleError(errMsg);
				}
			})
			.catch((e) =>
			{
				if(showDebug) console.error(e);
				this.handleError(getDefaultErrMsg() + " (Error-NL2)");
			});
		}

		// Shared "Thank You! / Please wait…" overlay heading+text, used both
		// on initial submit and when retrying after a reCAPTCHA failure.
		// Site-branched here (rather than adding a translations/nl/site.php
		// entry) since it's plain JS, not something Twig's |t filter can
		// reach.
		setDonationProcessingOverlayText()
		{
			if (allFormSettings.site_handle === 'ijmNl')
			{
				// "Bedankt!" (Thank You!) read as if the donation was already
				// complete at this point, when it's actually still being
				// redirected/processed -- client asked for "Doorsturen..."
				// (Redirecting...) instead.
				this.setOverlayHeading('Doorsturen...');
				this.setOverlayText('Een moment geduld, we verwerken uw donatie.');
			}
			else
			{
				this.setOverlayHeading('Thank You!');
				this.setOverlayText('Please wait while we process your donation.');
			}
		}

		watchFormSubmit()
		{

			this.form.addEventListener('submit', (e) =>
			{
				e.preventDefault();

				// Implicit form submission -- e.g. pressing Enter in a text
				// field -- fires this same 'submit' event without going
				// through any page-navigation click handler. Steps 1-3 all
				// share one <form>, and step 3's submit button is only
				// CSS-hidden on earlier steps, not removed, so an Enter
				// press on step 1 or 2 reaches here too. checkPageValidity()
				// below only confirms the *currently visible* page's own
				// fields are valid, not that the donor actually reached
				// step 3 -- so a fully-filled step 2 would otherwise sail
				// through into the payment logic before Stripe.js is even
				// initialized (that only happens in the "Continue to
				// Payment" click handler), crashing on a null stripe/
				// this.card. Bail out early unless step 3 is genuinely the
				// active page -- but only for a real, native SubmitEvent.
				// collectBankAccount() re-enters this same handler via a
				// plain, synthetic dispatchEvent(new Event('submit')) once
				// the ACH PaymentIntent is already confirmed, and that
				// always fires from step 2 -- the bank button never calls
				// changeToPage() the way the card flow's does, so the donor
				// stays on step 2's DOM the whole time behind the overlay.
				// A synthetic Event isn't a SubmitEvent, so gating on that
				// lets this legitimate re-entry through without reopening
				// the implicit-Enter hole for real browser submissions.
				if ( e instanceof SubmitEvent )
				{
					let activePage = this.dfc.querySelector('.jsFormPage.flex');
					if ( !activePage || !activePage.id.includes('form-page--3') )
					{
						if(showDebug) console.warn("Not proceeding: form was submitted from a page other than the final step.");
						return;
					}
				}

				// Check if the form validation
				if ( this.checkPageValidity() )
				{
					// Processing Step 1
					if(showDebug) console.info('Form submission initiated & page is valid, proceeding.');

					// progress
					this.overlayProcessing(true);
					this.setDonationProcessingOverlayText();
					this.setProgressBar(1);
					this.setProgressLabel(allFormSettings.site_handle === 'ijmNl' ? "Verwerken..." : "Processing...");
					this.showOverlay();

					// Get the Donation Captcha response
					if ( this.donationCaptchaResponse.value == "" )
					{

						if(showDebug) console.log('donationCaptchaResponse');
						// Trigger captcha if no captcha response found
						if ( this.form.dataset.formLocation == 'sidebar' )
						{
							if(showDebug) console.log('sidebar');

							// v3: Execute with action (loadRecaptcha() is a no-op if
							// the modal-open trigger already finished loading it)
							const trySidebarDonate = () => {
								getRecaptchaToken('sidebar_donate')
									.then((token) => {
										window.onSidebarDonationSubmit(token);
									})
									.catch((error) => {
										if (showDebug) console.error('reCAPTCHA v3 Error:', error);
										this.showRecaptchaFailure(() => {
											// Restore the "in progress" look this
											// flow already shows (set at the top
											// of the submit handler) before
											// retrying, so the donor doesn't see
											// a stale "Oops" screen if the retry
											// succeeds. (hideOverlayClose() already
											// ran as part of the retry click.)
											this.overlayProcessing(true);
											this.setDonationProcessingOverlayText();
											trySidebarDonate();
										});
									});
							};
							trySidebarDonate();

						}
						else
						{
							if(showDebug) console.log('main');

							// v3: Execute with action
							const tryMainDonate = () => {
								getRecaptchaToken('main_donate')
									.then((token) => {
										window.onMainDonationSubmit(token);
									})
									.catch((error) => {
										if (showDebug) console.error('reCAPTCHA v3 Error:', error);
										this.showRecaptchaFailure(() => {
											// Same reasoning as trySidebarDonate's
											// retry: restore the "in progress"
											// look before retrying.
											this.overlayProcessing(true);
											this.setDonationProcessingOverlayText();
											tryMainDonate();
										});
									});
							};
							tryMainDonate();
						}
					}
					else
					{
						if(showDebug) console.log('process donation');

						// IJM Netherlands (Findock): an entirely different payment
						// gateway with no client-side confirmation step at all --
						// branch once here at the architectural boundary (Findock
						// vs. Stripe), rather than threading site_handle checks
						// into the Stripe-specific branches below.
						if ( allFormSettings.site_handle === 'ijmNl' )
						{
							this.submitDonationFormNl();
						}
						// Bank (ACH): the PaymentIntent/Subscription invoice PaymentIntent
						// was already confirmed via Stripe Financial Connections in
						// collectBankAccount() before this submit was (re-)dispatched.
						else if ( this.form.dataset.paymentMethod == "bank" )
						{
							this.submitDonationForm();
						}
						// Card: confirm with Stripe.js first, then submit.
						else
						{

							// Prepare vars
							var cc_first_name = !!this.dfc.querySelector('input[name="billing_first_name"]') ? this.dfc.querySelector('input[name="billing_first_name"]').value : "";
							var cc_last_name = !!this.dfc.querySelector('input[name="billing_last_name"]') ? this.dfc.querySelector('input[name="billing_last_name"]').value : "";
							var cc_name = cc_first_name + " " + cc_last_name;
							var cc_address_country = !!this.dfc.querySelector('select[name="billing_country"]') ? this.dfc.querySelector('select[name="billing_country"]').value : "";
							var cc_address_state = !!this.dfc.querySelector('select[name="billing_state"]:not([disabled])') ? this.dfc.querySelector('select[name="billing_state"]:not([disabled])').value : "";
							var cc_address_zip = !!this.dfc.querySelector('input[name="billing_zip"]') ? this.dfc.querySelector('input[name="billing_zip"]').value : "";
							var cc_address_city = !!this.dfc.querySelector('input[name="billing_city"]') ? this.dfc.querySelector('input[name="billing_city"]').value : "";
							var cc_address_line1 = !!this.dfc.querySelector('input[name="billing_address"]') ? this.dfc.querySelector('input[name="billing_address"]').value : "";

							// var cc_first_name = !!this.form.billing_first_name ? this.form.billing_first_name.value.replaceAll('&', 'and').replaceAll('?', '') : "";
							// var cc_last_name = !!this.form.billing_last_name ? this.form.billing_last_name.value.replaceAll('&', 'and').replaceAll('?', '') : "";
							// var cc_name = cc_first_name + " " + cc_last_name;
							// var cc_address_line1 = !!this.form.billing_address ? this.form.billing_address.value.replaceAll('&', 'and').replaceAll('?', '') : "";
							// var cc_address_city = !!this.form.billing_city ? this.form.billing_city.value.replaceAll('&', 'and').replaceAll('?', '') : "";
							// var cc_address_zip = !!this.form.billing_zip ? this.form.billing_zip.value.replaceAll('&', 'and').replaceAll('?', '') : "";
							// var cc_address_country = !!this.form.billing_country ? this.form.billing_country.value.replaceAll('&', 'and').replaceAll('?', '') : "";

							// // Set the State value on if the country is CA
							// var cc_address_state = "";
							// if ( cc_address_country == 'CA' )
							// {
							//   cc_address_state = !!this.form.billing_state ? this.form.billing_state.value.replaceAll('&', 'and').replaceAll('?', '') : "";
							// }

							// Handle Donations
							try
							{

								// Retrieve the frequency
								let frequency = !!this.form.frequency ? this.form.frequency.value : "";
								var clientSecret = null;

								switch (frequency) {
									case 'monthly':
									case 'annually':
										clientSecret = !!this.form.querySelector('[name="subscription_client_secret"]') ? this.form.querySelector('[name="subscription_client_secret"]').value : null;
										break;

									default:
										clientSecret = !!this.form.querySelector('[name="client_secret"]') ? this.form.querySelector('[name="client_secret"]').value : null;
								}

								// Throw an error if the client secret is null
								if (clientSecret == null)
									throw getDefaultErrMsg() + " (Error-CSC0)";

								// Start Stripe Confirm Card Payment
								stripe.confirmCardPayment(clientSecret, {
								    payment_method: {
								      card: this.card,
								      billing_details: {
								        name: cc_name.trim(),
								        address: {
								          city: cc_address_city,
								          country: cc_address_country,
								          line1: cc_address_line1,
								          postal_code: cc_address_zip,
								          state: cc_address_state
								        }
								      }
								    }
								}).then( (result) => {
								    if (result.error)
								    {
								      // Show error to your customer (for example, insufficient funds)
								      let errMsg = !!result.error.message ? result.error.message + ' (Error-CSC1A)' : getDefaultErrMsg();
								      if(showDebug) console.log(errMsg);
								      this.handleError(errMsg);
								    }
								    else
								    {
								      	// The payment has been processed!
								      	let paymentIntentStatus = !!result.paymentIntent.status ? result.paymentIntent.status : "failed";
								      	if (paymentIntentStatus === 'succeeded')
								      	{
								      		// Debug: Show the Payment Intent Object
								        	if(showDebug) console.log('Payment Intent Object:');
								        	if(showDebug) console.log(result.paymentIntent);

								        	if ( result.paymentIntent == null )
								        		throw getDefaultErrMsg() + " (Error-CSC1B)";

								        	// Retrieve the Payment Intent Id
								        	let paymentIntent = result.paymentIntent;
								        	this.form.payment_intent_id.value = paymentIntent.id;

								        	// Debug: Show the Payment Intent Id
								        	if(showDebug) console.log("Payment Intent Id: " + paymentIntent.id);

								        	// Debug: Ensure the form has
								        	// the payment intent value
								        	if(showDebug) console.log("The Set Payment Intent Id");
								        	if(showDebug) console.log(this.form.payment_intent_id.value);

											this.submitDonationForm();
								      	}
								      	else
								      	{
								      		throw getDefaultErrMsg() + " (Error-CSC4)";
								      	}
								    }
								}).catch((error) => {
									// Without this, a Stripe API failure (network error, etc.)
									// or either throw above becomes an unhandled promise
									// rejection -- invisible to the surrounding try/catch, which
									// only covers the synchronous setup before this chain starts.
									// The donor would otherwise be stuck on the "processing"
									// overlay forever with no error shown.
									if(showDebug) console.error('stripe.confirmCardPayment() error:', error);
									let errMsg = (error && error.message) ? error.message : (typeof error === "string" ? error : getDefaultErrMsg() + ' (Error-CSC5)');
									this.handleError(errMsg);
								});

							}
							catch(e)
							{
								if(showDebug) console.log(e);
								this.handleError(e);
							}

						}
					}
				}
				else
				{
					if(showDebug) console.warn("Not proceeding since this page has form inputs that aren't valid.");
				}
			}); // this.form.addEventListener
		} // watchFormSubmit()

	/*
	##     ##    ###    ##    ## ########  ##       ########
	##     ##   ## ##   ###   ## ##     ## ##       ##
	##     ##  ##   ##  ####  ## ##     ## ##       ##
	######### ##     ## ## ## ## ##     ## ##       ######
	##     ## ######### ##  #### ##     ## ##       ##
	##     ## ##     ## ##   ### ##     ## ##       ##
	##     ## ##     ## ##    ## ########  ######## ########

	########  ########  ######  ########   #######  ##    ##  ######  ########
	##     ## ##       ##    ## ##     ## ##     ## ###   ## ##    ## ##
	##     ## ##       ##       ##     ## ##     ## ####  ## ##       ##
	########  ######    ######  ########  ##     ## ## ## ##  ######  ######
	##   ##   ##             ## ##        ##     ## ##  ####       ## ##
	##    ##  ##       ##    ## ##        ##     ## ##   ### ##    ## ##
	##     ## ########  ######  ##         #######  ##    ##  ######  ########
	*/

		handleAppDonateResponse(self, response)
		{
			// Initialize output
			var output = "";
			var form = self.form;

			// If redirect do so now
			if ( response.status == "ok" )
			{
				// Send SFMC stage 3 before resetting so billing fields are still available.
				this.sfmcLeadWrite(3);
				this.saveTrackingContext();

				// Reset the form for another donation
				form.reset();

				// Build URL
				var strURLParams = "";

				// Transaction Id
				if ( typeof response.result.id !== "undefined" )
				{
					strURLParams += strURLParams === "" ? "?" : "&";
					strURLParams += "id=" + encodeURIComponent(response.result.id);
				}
				// Amount
				if ( typeof response.result.amount !== "undefined" )
				{
					strURLParams += strURLParams === "" ? "?" : "&";
					strURLParams += "amount=" + encodeURIComponent(response.result.amount);
				}
				// Frequency
				if ( typeof response.result.frequency !== "undefined" )
				{
					strURLParams += strURLParams === "" ? "?" : "&";
					strURLParams += "frequency=" + encodeURIComponent(response.result.frequency);
				}

				// Processing Step 4
				this.setProgressBar(4);
				this.setProgressLabel('Redirecting...');

				if (allFormSettings.do_redirect_env)
				{
					// Handle success
					if ( typeof response.result.redirect_to !== "undefined" )
					{

						window.location.href = response.result.redirect_to + strURLParams;
						//if(showDebug) console.log('window.location.href = ' + response.result.redirect_to + strURLParams);
					}
					else
					{
						window.location.href = '/give/thank-you' + strURLParams;
					}
				}
				else
				{

					// Handle success
					if ( typeof response.result.redirect_to !== "undefined" )
					{

						// window.location.href = response.result.redirect_to + strURLParams;
						if(showDebug) console.log('window.location.href = ' + response.result.redirect_to + strURLParams);
					}
					else
					{
						// window.location.href = '/give/thank-you' + strURLParams;
						if(showDebug) console.log('window.location.href = "/give/thank-you"' + strURLParams);
					}
				}

			}
			else // response.status is NOT "ok"
			{

				// Reset the donation form captcha (v3: clear token if needed)
				self.donationCaptchaResponse.value = '';

				// If error response, output response
				// otherwise redirect
				if ( response.message != "" )
				{
					output += response.message;
				}
				// General error
				else
				{
					output = allFormSettings.site_handle === 'ijmNl' ? 'Verwerken van de betaling is mislukt.' : 'Failed to process payment.';
				}
			}

			// Output response
			if ( output != "" )
			{
				// Some callers reach this point without ever having shown
				// the overlay -- handleStripeClientSecret()'s check_customer
				// flow (triggered by the bank/card "Enter Payment Details"
				// buttons) only opens it on the reCAPTCHA-failure branch
				// (showRecaptchaFailure()), not on a client-secret.php
				// failure or network error. Without this, this exact "Oops"
				// content gets written into the DOM but the overlay section
				// itself stays invisible (opacity-0/invisible until
				// .-shown is added) -- a silent failure with no visible
				// error at all. Idempotent/harmless for callers that
				// already showed it (e.g. mid-submit failures).
				this.showOverlay();
				this.overlayProcessing(false);
				this.setOverlayHeading(allFormSettings.site_handle === 'ijmNl' ? 'Oeps' : 'Oops');
				this.setOverlayText(output);
				this.showOverlayClose();
			}
		}

		// IJM Netherlands (Findock) response handler -- deliberately NOT
		// routed through handleAppDonateResponse() above. That method
		// appends "?id=...&amount=...&frequency=..." onto
		// response.result.redirect_to before navigating, which assumes an
		// internal, query-string-free URL like "/give/thank-you". Findock's
		// own result.redirect_to is different in kind, not just sharing the
		// name coincidentally: for card/iDEAL it's an external, already-
		// query-stringed Findock/Stripe-Checkout URL, and for Direct Debit
		// it's the plain success URL -- decorating either the same way
		// would produce a malformed URL. So this just navigates straight to
		// result.redirect_to.
		handleAppDonateResponseNl(self, response)
		{
			if ( response.status == "ok" )
			{
				let redirectUrl = (response.result && response.result.redirect_to) ? response.result.redirect_to : '';

				if ( redirectUrl == '' )
				{
					this.handleError(getDefaultErrMsg() + ' (Error-NL3)');
					return;
				}

				// Send SFMC stage 3 before resetting so billing fields are
				// still available, same as the Stripe path.
				this.sfmcLeadWrite(3);
				this.saveTrackingContext();

				// Reset the form for another donation
				self.form.reset();

				this.setProgressBar(4);
				this.setProgressLabel('Doorsturen...');

				if (allFormSettings.do_redirect_env)
				{
					window.location.replace(redirectUrl);
				}
				else if (showDebug)
				{
					console.log('window.location.replace(' + redirectUrl + ')');
				}
			}
			else // response.status is NOT "ok"
			{
				// Reset the donation form captcha (v3: clear token if needed)
				self.donationCaptchaResponse.value = '';

				let output = (response.message != "") ? response.message : 'Verwerken van de betaling is mislukt.';

				this.overlayProcessing(false);
				this.setOverlayHeading('Oeps');
				this.setOverlayText(output);
				this.showOverlayClose();
			}
		}

	}

	// Retrieve all donation form containers
	let donationFormContainers = document.querySelectorAll('.jsDonationFormContainer');

	// Loop through and init all of the donation forms on a page
	donationFormContainers.forEach(donationFormContainer => {
		new DonationForm(donationFormContainer, allFormSettings);
	});

} // if (typeof allFormSettings !== 'undefined')